import { OrderedMap } from "immutable";


import { FORM_FIELD_RULES } from "./form-field-rules";
import {
    // APPLICANT_TYPES,
    GENDER_TYPES,
    NATURE_OF_ASSOCIATION_TYPES,
    SUPPLY_CHAIN_ROLE_TYPE_CHOICE,
    PRODUCT_INTEREST_TYPES,
    INTEREST_DEFINITION_TYPES,
    PRODUCT_FEE_TYPES,
    FEE_DEBIT_AT_TYPES,
    FEE_CALCULATION_TYPES,
    DUE_DATE_FROM_TYPES,
    CASE_LEAD_TYPES,
    INDUSTRY_CATEGORY_TYPES,
    CASE_PRIORITY_TYPES,
    PROFESSION_TYPES,
    MARITIAL_STATUS_TYPES,
    FEE_BASIS_TYPE, 
    CHARGES_AT_TYPE, 
    PAYMEN_FREQUENCY_TYPE,
    SECURITY_TYPES,
    SECURITY_BASIS,
    BUSINESS_PRODUCT_TYPE,
    PROGRAM_TYPE_NEW,
    ONBOARDING_ASSOCIATION_TYPES,
    RECOURSE_STRUCTURE,
    BANK_ACCOUNT_TYPES,
    NACH_MODES_TYPE,
    SERIES_FUNDED
} from "constants/enums";
import { INPUT_TYPES } from "./input-types";
import moment from "moment";
// import AddNameForm from "forms/add-name-form";
import AddAddressForm from "forms/add-address-form";

export const AUTH_FORM_FIELDS = new OrderedMap({
    username: {
        type: INPUT_TYPES.EMAIL,
        rules: [
            {
                required: true,
                message: FORM_FIELD_RULES.USERNAME_REQUIRED
            }
        ],
        placeholder: "john.doe@gmail.com",
        label: "Username"
    },
    password: {
        type: INPUT_TYPES.PASSWORD,
        label: "Password",
        rules: [
            {
                required: true,
                message: FORM_FIELD_RULES.PASSWORD_REQUIRED
            }
        ]
    }
});

export const FORGOT_PASSWORD_EMAIL_FORM = new OrderedMap({
    email: {
        type: INPUT_TYPES.EMAIL,
        rules: [
            {
                required: true,
                message: FORM_FIELD_RULES.USERNAME_REQUIRED
            },
            {
                type: "email",
                message: "Please enter a valid email address"
            }
        ],
        placeholder: "john.doe@gmail.com",
        label: "Email"
    }
});

export const FORGOT_NEW_PASSWORD_FORM = new OrderedMap({
    otp: {
        type: INPUT_TYPES.PASSWORD,
        label: "Enter OTP",
        rules: [
            {
                required: true,
                message: FORM_FIELD_RULES.PASSWORD_REQUIRED
            }
        ]
    },
    new_password: {
        type: INPUT_TYPES.PASSWORD,
        label: "Enter New Password",
        rules: [
            {
                required: true,
                message: FORM_FIELD_RULES.PASSWORD_REQUIRED
            }
        ]
    },
    confirm_new_password: {
        type: INPUT_TYPES.PASSWORD,
        label: "Confirm Password",
        rules: [
            {
                required: true,
                message: FORM_FIELD_RULES.PASSWORD_REQUIRED
            }
        ]
    }
});

export const RESET_PASSWORD_FIELDS = new OrderedMap({
    currentPassword: {
        type: INPUT_TYPES.PASSWORD,
        label: "Enter Current Password",
        rules: [
            {
                required: true,
                message: FORM_FIELD_RULES.PASSWORD_REQUIRED
            }
        ]
    },
    newPassword: {
        type: INPUT_TYPES.PASSWORD,
        label: "Enter New Password",
        rules: [
            {
                required: true,
                message: FORM_FIELD_RULES.PASSWORD_REQUIRED
            }
        ]
    },
    confirmPassword: {
        type: INPUT_TYPES.PASSWORD,
        label: "Confirm Password",
        rules: [
            {
                required: true,
                message: FORM_FIELD_RULES.PASSWORD_REQUIRED
            }
        ]
    }
});

export const CAB_ENGINE_OVERALL_PARAMETERS = new OrderedMap({
    anchor: {
        className: "form-field",
        type: INPUT_TYPES.SELECT,
        placeholder: "Anchor",
        options: [{}]
    },
    tranche_tenure: {
        className: "form-field",
        type: INPUT_TYPES.SELECT,
        placeholder: "Tranche Tenure (days)",
        options: [{}]
    },
    limit_tenure: {
        className: "form-field",
        type: INPUT_TYPES.SELECT,
        placeholder: "Limit Tenure (months)",
        options: [{}]
    },
    age_norms: {
        className: "form-field",
        type: INPUT_TYPES.SELECT,
        placeholder: "Age Norms",
        options: [{}]
    },
    ca_applicant: {
        className: "form-field",
        type: INPUT_TYPES.SELECT,
        placeholder: "Co-Applicant",
        options: [{}]
    },
    constitution_type: {
        className: "form-field",
        type: INPUT_TYPES.SELECT,
        placeholder: "Constitution Type",
        options: [{}]
    },
    per_dependency: {
        className: "form-field",
        type: INPUT_TYPES.SELECT,
        placeholder: "% Dependence",
        options: [{}]
    },
    overall_business_vintage: {
        className: "form-field",
        type: INPUT_TYPES.SELECT,
        placeholder: "Overall Business Vintage (months)",
        options: [{}]
    },
    business_vinatge_with_anchor: {
        className: "form-field",
        type: INPUT_TYPES.SELECT,
        placeholder: "Business Vinatge with Anchor (months)",
        options: [{}]
    },
    progcap_score: {
        className: "form-field",
        type: INPUT_TYPES.SELECT,
        placeholder: "Progcap Score",
        options: [{}]
    },
    ownership_proof_submited: {
        className: "form-field",
        type: INPUT_TYPES.SELECT,
        placeholder: "Ownership Proof Submitted",
        options: [{}]
    },
    sanction_amount: {
        className: "form-field",
        type: INPUT_TYPES.SELECT,
        placeholder: "Sanction Amount",
        options: [{}]
    },
    cheque_bounce_in_last_six_months: {
        className: "form-field",
        type: INPUT_TYPES.SELECT,
        placeholder: "Cheque Bounce in last 6 months (Non-Technical)",
        options: [{}]
    },
    emi_bounce_in_last_six_months: {
        className: "form-field",
        type: INPUT_TYPES.SELECT,
        placeholder: "EMI Bounce in last 6 months (Non-Technical)",
        options: [{}]
    },
    net_worth: {
        className: "form-field",
        type: INPUT_TYPES.SELECT,
        placeholder: "New-worth/Capital",
        options: [{}]
    },
    leverage_ratio: {
        className: "form-field",
        type: INPUT_TYPES.SELECT,
        placeholder: "Leverage Ratio",
        options: [{}]
    },
    internet_service_coverage_ratio: {
        className: "form-field",
        type: INPUT_TYPES.SELECT,
        placeholder: "Internet Service Coverage Ratio",
        options: [{}]
    },
    instances_of_dpd: {
        className: "form-field",
        type: INPUT_TYPES.SELECT,
        placeholder: "Instances of 60+ DPD in last 6 months",
        options: [{}]
    },
    debt_ratio: {
        className: "form-field",
        type: INPUT_TYPES.SELECT,
        placeholder: "Debt/Equity Ratio",
        options: [{}]
    },
    gearing: {
        className: "form-field",
        type: INPUT_TYPES.SELECT,
        placeholder: "Gearing (TOI/TNW)",
        options: [{}]
    },
    in_customer_ntb: {
        className: "form-field",
        type: INPUT_TYPES.SELECT,
        placeholder: "In Customer NTB",
        options: [{}]
    },
    gst_filing_delay: {
        className: "form-field",
        type: INPUT_TYPES.SELECT,
        placeholder: "GST filing delay",
        options: [{}]
    },
    deviation_to_bureau_norms: {
        className: "form-field",
        type: INPUT_TYPES.SELECT,
        placeholder: "Deviation to bureau norms",
        options: [{}]
    },
    dscr: {
        className: "form-field",
        type: INPUT_TYPES.SELECT,
        placeholder: "DSCR",
        options: [{}]
    },
    total_banking_credits: {
        className: "form-field",
        type: INPUT_TYPES.SELECT,
        placeholder: "Total Banking Credits>Last 3 month purchase",
        options: [{}]
    },
    geography: {
        className: "form-field",
        type: INPUT_TYPES.SELECT,
        placeholder: "Geography",
        options: [{}]
    },
    shop_ownership: {
        className: "form-field",
        type: INPUT_TYPES.SELECT,
        placeholder: "Shop ownership",
        options: [{}]
    },
    residence_ownership: {
        className: "form-field",
        type: INPUT_TYPES.SELECT,
        placeholder: "Residence ownership",
        options: [{}]
    },
});

export const APPLICANT_FIELDS_ASSOCIATE = new OrderedMap({
    first_name: {
        type: INPUT_TYPES.TEXT,
        placeholder: "First & Middle Name",
        className: "form-field",
        rules: [
            {
                required: true,
                message: "First Name is Required"
            },
            {
                pattern: /^[a-zA-Z ]+$/,
                message: "Enter Valid Name"
            }
        ]
    },
    // middle_name: {
    //     type: INPUT_TYPES.TEXT,
    //     placeholder: "Middle Name",
    //     className: "form-field",
    //     rules:[
    //         {
    //             //eslint-disable-next-line
    //             pattern:  /^[a-zA-Z ]+$/,
    //             message: "Enter valid Name"
    //         }
    //     ]
    // },
    last_name: {
        type: INPUT_TYPES.TEXT,
        placeholder: "Last Name",
        className: "form-field",
        rules: [
            {
                required: true,
                message: "Last Name is Required"
            },
            {
                pattern: /^[a-zA-Z ]+$/,
                message: "Enter Valid Name"
            }
        ]
    },
    aadhar: {
        className: "form-field",
        type: INPUT_TYPES.TEXT,
        placeholder: "Aadhaar",
        disabled: true,
        rules: [
            // {
            //     required: true,
            //     message: "Aadhaar is Required"
            // },
            // {
            //     pattern: /^\d{12}$/g,
            //     message: "Does not match Format"
            // }
        ],

    },
    gender: {
        className: "form-field",
        type: INPUT_TYPES.SELECT,
        placeholder: "Gender",
        options: GENDER_TYPES.map((value, key) => ({
            value,
            label: key
        })).toList(),
        rules: [
            {
                required: true,
                message: "Gender is Required"
            },
        ]
    },
    marital_status: {
        className: "form-field",
        // size: "small",
        type: INPUT_TYPES.SELECT,
        placeholder: "Marital Status",
        options: MARITIAL_STATUS_TYPES.map((value, key) => ({
            label: key,
            value
        })).toList(),
        rules: [
            {
                required: true,
                message: "Marital Status is Required"
            },
        ]
    },
    father_name: {
        className: "form-field",
        type: INPUT_TYPES.TEXT,
        placeholder: "Father Name",
        disabled: true,
        rules:[
            {
                required: true,
                message: "Father Name is Required"
            },
            {
                //eslint-disable-next-line
                pattern: /^[a-zA-Z ]+$/,
                message: "Enter valid Name"
            }
        ]
    },
    spouse_name: {
        className: "form-field",
        type: INPUT_TYPES.TEXT,
        placeholder: "Spouse Name",
        disabled: true,
        rules:[
            {
                //eslint-disable-next-line
                pattern: /^[a-zA-Z ]+$/,
                message: "Enter valid Name"
            }
        ]
    },
    mother_name: {
        className: "form-field",
        type: INPUT_TYPES.TEXT,
        placeholder: "Mother Maidan Name",
        rules:[
            {
                
                //eslint-disable-next-line
                pattern: /^[a-zA-Z ]+$/,
                message: "Enter valid Name"
            }
        ]
    },
    dob: {
        className: "form-field",
        // size: "small",
        type: INPUT_TYPES.DATE,
        disabledDate: value =>
            value.valueOf() >=
            moment()
                .subtract("days", 1)
                .valueOf(),
        placeholder: "Date of Birth",
        rules: [
            {
                required: true,
                message: "Date of Birth is Required"
            },
        ]
    },
    phone: {
        className: "form-field",
        type: INPUT_TYPES.TEXT,
        placeholder: "Phone Number",
        rules: [
            {
                required: true,
                message: "Mobile Number is Required"
            },
            {
                min: 10,
                message: "Enter valid mobile number "
            },
            {
                max: 10,
                message: "Enter valid mobile number "
            },
            {
                pattern: /^(?:\d*)$/,
                message: "Value should contain just number",
            },
        ]
    },
    phone_residence: {
        className: "form-field",
        type: INPUT_TYPES.TEXT,
        placeholder: "Alternate Phone Number",
        rules: [
            {
                min: 10,
                message: "Enter valid mobile number "
            },
            {
                max: 10,
                message: "Enter valid mobile number "
            },
            {
                pattern: /^(?:\d*)$/,
                message: "Value should contain just number",
            },
        ]
    },
    phone_office: {
        className: "form-field",
        type: INPUT_TYPES.TEXT,
        placeholder: "Office Phone no/Landline"
    },
    email: {
        className: "form-field",
        type: INPUT_TYPES.EMAIL,
        placeholder: "Email",
        rules: [
            {
                required: true,
                message: "E-mail is Required"
            },
            {
                pattern: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                message: "Enter valid Email"
            }
        ]
    },
    nature_of_association: {
        className: "form-field",
        type: INPUT_TYPES.SELECT,
        placeholder: "Title",
        options: NATURE_OF_ASSOCIATION_TYPES.map((value, key) => ({
            label: key,
            value
        })).toList(),
        rules: [
            {
                required: true,
                message: "Title is Required"
            },
        ]
    },
    profession: {
        className: "form-field",
        type: INPUT_TYPES.SELECT,
        placeholder: "Profession",
        options: PROFESSION_TYPES.map((value, key) => ({
            label: key,
            value
        })).toList(),
        rules: [
            {
                required: true,
                message: "Profession is Required"
            },
        ]
    },
    pan: {
        className: "form-field",
        type: INPUT_TYPES.TEXT,
        placeholder: "PAN",
        rules: [
            {
                required: true,
                message: "PAN is required"
            },
            {
                max: 10,
                message: "Please Enter a valid PAN No"
            },
            {
                pattern: "[A-Z]{5}[0-9]{4}[A-Z]{1}",
                message: "Please Enter a valid PAN No"
            }
        ]
    },
    residence_address: {
        className: "form-field",
        type: INPUT_TYPES.OBJECT_TEXT,
        placeholder: "Residence Address",
        inputForm: AddAddressForm,
        inputformprops: {
            addressTypes: [5]
        },
        rules: [
            {
                required: true,
                message: "Residence Address is Required"
            },
        ],
        getValueFromObject: address =>
            address ? `${address.address_line_1} ${address.city && address.city.name ? address.city.name : ""}` : null
    },
    permanent_address: {
        className: "form-field",
        type: INPUT_TYPES.OBJECT_TEXT,
        placeholder: "Permanent Address",
        inputForm: AddAddressForm,
        inputformprops: {
            addressTypes: [6]
        },
        rules: [
            {
                required: true,
                message: "Permanent Address is Required"
            },
        ],
        getValueFromObject: address =>
            address ? `${address.address_line_1} ${address.city && address.city.name ? address.city.name : ""}` : null
    },
    annual_income: {
        className: "form-field",
        type: INPUT_TYPES.NUMBER,
        placeholder: "Annual Income"
    },
    shareholding: {
        className: "form-field",
        type: INPUT_TYPES.NUMBER,
        placeholder: "Shareholding",
        rules: [
            {
                required: true,
                message: "Shareholding is required"
            },
            // {
            //     pattern: /^\d*[1-9]\d*$/,
            //     message: "Shareholding cannot be 0"
            // }
        ]},
    name_pan: {
        className: "form-field",
        type: INPUT_TYPES.TEXT,
        placeholder: "Name as on PAN",
        rules:[
            {
                required: true,
                message: "Name as on PAN is Required"
            },
            {
                //eslint-disable-next-line
                pattern: /^[a-zA-Z ]+$/,
                message: "Enter valid Name"
            }
        ]
    },
    dob_pan: {
        className: "form-field",
        type: INPUT_TYPES.DATE,
        placeholder: "Date of Birth as on PAN",
        rules: [
            {
                required: true,
                message: "DOB as on PAN is Required"
            },
        ]
    },
    name_aadhar: {
        className: "form-field",
        type: INPUT_TYPES.TEXT,
        placeholder: "Name as on Aadhar",
        rules:[
            {
                required: true,
                message: "Name as on Aadhar is Required"
            },
            {
                //eslint-disable-next-line
                pattern: /^[a-zA-Z ]+$/,
                message: "Enter valid Name"
            }
        ]
    },
    dob_aadhar: {
        className: "form-field",
        type: INPUT_TYPES.DATE,
        placeholder: "Date of Birth as on Aadhar (YYYY-MM-DD)",
        rules: [
            {
                required: true,
                message: "DOB as on Aadhar is Required"
            },
        ]
    },
    name_gst: {
        className: "form-field",
        type: INPUT_TYPES.TEXT,
        placeholder: "Name as on GST",
        rules:[
            {
                required: true,
                message: "Name as on GST is Required"
            },
            {
                //eslint-disable-next-line
                pattern: /^[a-zA-Z ]+$/,
                message: "Enter valid Name"
            }
        ]
    },
    name_pdeed: {
        className: "form-field",
        type: INPUT_TYPES.TEXT,
        placeholder: "Name as on Partnership Deed",
        rules:[
            {
                //eslint-disable-next-line
                pattern: /^[a-zA-Z ]+$/,
                message: "Enter valid Name"
            }
        ]
    },
    remove: {
        className: "form-field",
        type: INPUT_TYPES.BUTTON,
        btnType: "link",
        placeholder: "Remove"
    },
    aadhar_pan_link_document: {
        className: "form-field",
        type: INPUT_TYPES.BUTTON,
        btnType: "link",
        placeholder: "Aadhar Pan Link"
    },
    refresh_pan_aadhar_link: {
        className: "form-field",
        type: INPUT_TYPES.BUTTON,
        btnType: "link",
        placeholder: "Refresh Link",
    }
});


export const APPLICANT_FIELDS = new OrderedMap({
    first_name: {
        type: INPUT_TYPES.TEXT,
        placeholder: "First Name",
        className: "form-field",
        rules: [
            {
                required: true,
                message: "First Name is Required"
            },
            {
                pattern: /^[a-zA-Z ]+$/,
                message: "Enter Valid Name"
            }
        ]
    },
    middle_name: {
        type: INPUT_TYPES.TEXT,
        placeholder: "Middle Name",
        className: "form-field",
        rules:[
            {
                //eslint-disable-next-line
                pattern:  /^[a-zA-Z ]+$/,
                message: "Enter valid Name"
            }
        ]
    },
    last_name: {
        type: INPUT_TYPES.TEXT,
        placeholder: "Last Name",
        className: "form-field",
        rules: [
            {
                required: true,
                message: "Last Name is Required"
            },
            {
                pattern: /^[a-zA-Z ]+$/,
                message: "Enter Valid Name"
            }
        ]
    },
    aadhar: {
        className: "form-field",
        type: INPUT_TYPES.TEXT,
        placeholder: "Aadhaar",
        disabled: true,
        rules: [
            {
                required: true,
                message: "Aadhaar is Required"
            },
            // {
            //     pattern: /^\d{12}$/g,
            //     message: "Does not match Format"
            // }
        ],

    },
    gender: {
        className: "form-field",
        type: INPUT_TYPES.SELECT,
        placeholder: "Gender",
        options: GENDER_TYPES.map((value, key) => ({
            value,
            label: key
        })).toList(),
        rules: [
            {
                required: true,
                message: "Gender is Required"
            },
        ]
    },
    marital_status: {
        className: "form-field",
        // size: "small",
        type: INPUT_TYPES.SELECT,
        placeholder: "Marital Status",
        options: MARITIAL_STATUS_TYPES.map((value, key) => ({
            label: key,
            value
        })).toList(),
        rules: [
            {
                required: true,
                message: "Marital Status is Required"
            },
        ]
    },
    father_name: {
        className: "form-field",
        type: INPUT_TYPES.TEXT,
        placeholder: "Father Name",
        disabled: true,
        rules:[
            {
                required: true,
                message: "Father Name is Required"
            },
            {
                //eslint-disable-next-line
                pattern: /^[a-zA-Z ]+$/,
                message: "Enter valid Name"
            }
        ]
    },
    spouse_name: {
        className: "form-field",
        type: INPUT_TYPES.TEXT,
        placeholder: "Spouse Name",
        disabled: true,
        rules:[
            {
                //eslint-disable-next-line
                pattern: /^[a-zA-Z ]+$/,
                message: "Enter valid Name"
            }
        ]
    },
    mother_name: {
        className: "form-field",
        type: INPUT_TYPES.TEXT,
        placeholder: "Mother Maidan Name",
        rules:[
            {
                
                //eslint-disable-next-line
                pattern: /^[a-zA-Z ]+$/,
                message: "Enter valid Name"
            }
        ]
    },
    dob: {
        className: "form-field",
        // size: "small",
        type: INPUT_TYPES.DATE,
        disabledDate: value =>
            value.valueOf() >=
            moment()
                .subtract("days", 1)
                .valueOf(),
        placeholder: "Date of Birth",
        rules: [
            {
                required: true,
                message: "Date of Birth is Required"
            },
        ]
    },
    phone: {
        className: "form-field",
        type: INPUT_TYPES.TEXT,
        placeholder: "Phone Number",
        rules: [
            {
                required: true,
                message: "Mobile Number is Required"
            },
            {
                min: 10,
                message: "Enter valid mobile number "
            },
            {
                max: 10,
                message: "Enter valid mobile number "
            },
            {
                pattern: /^(?:\d*)$/,
                message: "Value should contain just number",
            },
        ]
    },
    phone_residence: {
        className: "form-field",
        type: INPUT_TYPES.TEXT,
        placeholder: "Alternate Phone Number",
        rules: [
            {
                min: 10,
                message: "Enter valid mobile number "
            },
            {
                max: 10,
                message: "Enter valid mobile number "
            },
            {
                pattern: /^(?:\d*)$/,
                message: "Value should contain just number",
            },
        ]
    },
    phone_office: {
        className: "form-field",
        type: INPUT_TYPES.TEXT,
        placeholder: "Office Phone no/Landline"
    },
    email: {
        className: "form-field",
        type: INPUT_TYPES.EMAIL,
        placeholder: "Email",
        rules: [
            {
                required: true,
                message: "E-mail is Required"
            },
            {
                pattern: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                message: "Enter valid Email"
            }
        ]
    },
    nature_of_association: {
        className: "form-field",
        type: INPUT_TYPES.SELECT,
        placeholder: "Title",
        options: NATURE_OF_ASSOCIATION_TYPES.map((value, key) => ({
            label: key,
            value
        })).toList(),
        rules: [
            {
                required: true,
                message: "Title is Required"
            },
        ]
    },
    profession: {
        className: "form-field",
        type: INPUT_TYPES.SELECT,
        placeholder: "Profession",
        options: PROFESSION_TYPES.map((value, key) => ({
            label: key,
            value
        })).toList(),
        rules: [
            {
                required: true,
                message: "Profession is Required"
            },
        ]
    },
    pan: {
        className: "form-field",
        type: INPUT_TYPES.TEXT,
        placeholder: "PAN",
        rules: [
            {
                required: true,
                message: "PAN is required"
            },
            {
                max: 10,
                message: "Please Enter a valid PAN No"
            },
            {
                pattern: "[A-Z]{5}[0-9]{4}[A-Z]{1}",
                message: "Please Enter a valid PAN No"
            }
        ]
    },
    residence_address: {
        className: "form-field",
        type: INPUT_TYPES.OBJECT_TEXT,
        placeholder: "Residence Address",
        inputForm: AddAddressForm,
        inputformprops: {
            addressTypes: [5]
        },
        rules: [
            {
                required: true,
                message: "Residence Address is Required"
            },
        ],
        getValueFromObject: address =>
            address ? `${address.address_line_1} ${address.city && address.city.name ? address.city.name : ""}` : null
    },
    permanent_address: {
        className: "form-field",
        type: INPUT_TYPES.OBJECT_TEXT,
        placeholder: "Permanent Address",
        inputForm: AddAddressForm,
        inputformprops: {
            addressTypes: [6]
        },
        rules: [
            {
                required: true,
                message: "Permanent Address is Required"
            },
        ],
        getValueFromObject: address =>
            address ? `${address.address_line_1} ${address.city && address.city.name ? address.city.name : ""}` : null
    },
    annual_income: {
        className: "form-field",
        type: INPUT_TYPES.NUMBER,
        placeholder: "Annual Income"
    },
    shareholding: {
        className: "form-field",
        type: INPUT_TYPES.NUMBER,
        placeholder: "Shareholding",
        rules: [
            {
                required: true,
                message: "Shareholding is required"
            },
            // {
            //     pattern: /^\d*[1-9]\d*$/,
            //     message: "Shareholding cannot be 0"
            // }
        ]},
    name_pan: {
        className: "form-field",
        type: INPUT_TYPES.TEXT,
        placeholder: "Name as on PAN",
        rules:[
            {
                required: true,
                message: "Name as on PAN is Required"
            },
            {
                //eslint-disable-next-line
                pattern: /^[a-zA-Z ]+$/,
                message: "Enter valid Name"
            }
        ]
    },
    dob_pan: {
        className: "form-field",
        type: INPUT_TYPES.DATE,
        placeholder: "Date of Birth as on PAN",
        rules: [
            {
                required: true,
                message: "DOB as on PAN is Required"
            },
        ]
    },
    name_aadhar: {
        className: "form-field",
        type: INPUT_TYPES.TEXT,
        placeholder: "Name as on Aadhar",
        rules:[
            {
                required: true,
                message: "Name as on Aadhar is Required"
            },
            {
                //eslint-disable-next-line
                pattern: /^[a-zA-Z ]+$/,
                message: "Enter valid Name"
            }
        ]
    },
    dob_aadhar: {
        className: "form-field",
        type: INPUT_TYPES.DATE,
        placeholder: "Date of Birth as on Aadhar (YYYY-MM-DD)",
        rules: [
            {
                required: true,
                message: "DOB as on Aadhar is Required"
            },
        ]
    },
    name_gst: {
        className: "form-field",
        type: INPUT_TYPES.TEXT,
        placeholder: "Name as on GST",
        rules:[
            {
                required: true,
                message: "Name as on GST is Required"
            },
            {
                //eslint-disable-next-line
                pattern: /^[a-zA-Z ]+$/,
                message: "Enter valid Name"
            }
        ]
    },
    name_pdeed: {
        className: "form-field",
        type: INPUT_TYPES.TEXT,
        placeholder: "Name as on Partnership Deed",
        rules:[
            {
                //eslint-disable-next-line
                pattern: /^[a-zA-Z ]+$/,
                message: "Enter valid Name"
            }
        ]
    },
    remove: {
        className: "form-field",
        type: INPUT_TYPES.BUTTON,
        btnType: "link",
        placeholder: "Remove"
    }
});

export const BRANDS_TABLE_FORM = new OrderedMap({
    channel_product: {
        label: "Product Label",
        placeholder: "Product Label",
        type: INPUT_TYPES.OBJECT_SELECT,
        disabled: false,
        showSearch: true,
        // defaultValue: 1,
        labelProp: "name",
        options: []
    },
    seller_name: {
        label: "Seller",
        placeholder: "",
        type: INPUT_TYPES.TEXT,
        disabled: false,
    },
    name: {
        label: "Product Name",
        placeholder: "Product Name",
        type: INPUT_TYPES.TEXT,
        disabled: false
    },
    value: {
        rules: [{ required: true, message: "Please add Value Amount" }],
        label: "Value",
        placeholder: "XXXXXXXXX",
        type: INPUT_TYPES.TEXT,
        disabled: false,
        grouped: true,
        addAfter: {
            name: "value_type",
            affix: "prefix",
            type: INPUT_TYPES.SELECT,
            defaultValue: 2,
            style: {
                width: "60px"
            },
            options: [
                {
                    label: "%",
                    value: 2
                },
                {
                    label: "Rs",
                    value: 1
                }
            ]
        }
    },
    from_period: {
        label: "From Period",
        placeholder: "yyyy-mm-dd",
        type: INPUT_TYPES.DATE,
        disabled: false
    },
    to_period: {
        label: "To Period",
        placeholder: "yyyy-mm-dd",
        type: INPUT_TYPES.DATE,
        disabled: false
    }
});
export const UNDERWRITING_JOB_FIELDS = new OrderedMap({
    distributor: {
        label: "Distributor",
        placeholder: "Distributor",
        type: INPUT_TYPES.OBJECT_SELECT,
        className: "form-field fb-20",
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ],
        options: []
    },
    gstin: {
        type: INPUT_TYPES.OBJECT_TEXT,
        placeholder: "GSTIN",
        className: "form-field fb-30",
        disabled: false,
        label: "GSTIN",
        getValueFromObject: company => company && company.gstin ? company.gstin : null
    },
    generate_welcome_email: {
        label: "Generate Welcome Email",
        type: INPUT_TYPES.RADIO,
        defaultValue: false,
        options: [{ label: "Yes", value: true }, { label: "No", value: false }],
        className: "form-field fb-30"
    }
});

export const BUSINESS_PROGRAM_FORM_FIELDS = new OrderedMap({
    business_product: {
        label: "Business Product",
        placeholder: "Business Product",
        type: INPUT_TYPES.SELECT,
        options: [],
        style: {
            minWidth: 200,
            maxWidth: 250
        },
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ],
        className: "form-field fb-20"
    },
    program_type: {
        label: "Program Type",
        placeholder: "Program Type",
        type: INPUT_TYPES.SELECT,

        disabled: true,
        options: SUPPLY_CHAIN_ROLE_TYPE_CHOICE.map((_, k) => ({
            label: k,
            value: _
        })).toList(),
        style: {
            minWidth: 200,
            maxWidth: 250
        },
        // options: [],
        className: "form-field fb-20",
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ]
    },
    company: {
        label: "Company",
        placeholder: "Company",
        labelProp: "gstin|name",
        showSearch: true,
        disabled: true,
        type: INPUT_TYPES.OBJECT_SELECT,
        options: [],
        style: {
            minWidth: 200,
            maxWidth: 250
        },
        dropdownMenuStyle: {
            minWidth: 500
        },
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ],
        className: "form-field fb-20"
    },
    parent_program: {
        label: "Parent Business Program",
        placeholder: "Parent Program",
        type: INPUT_TYPES.OBJECT_SELECT,
        disabled: true,
        style: {
            minWidth: 200,
            maxWidth: 250
        },
        dropdownMenuStyle: {
            minWidth: 500
        },
        showSearch: true,
        options: [],
        labelProp: "label",
        className: "form-field fb-20"
    }
});

export const BUSINESS_BASIC_DETAIL_FORM = new OrderedMap({
    program_size: {
        label: "Program Size",
        type: INPUT_TYPES.FLOAT,
        placeholder: "Program Size",
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ],
        className: "form-field fb-20"
    },
    limit_max: {
        label: "Max Limit",
        placeholder: "Max Limit",
        type: INPUT_TYPES.FLOAT,
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ],
        className: "form-field fb-20"
    },
    is_higher_limit_allowed: {
        label: "Is Higher Limit Allowed ?",
        type: INPUT_TYPES.RADIO,
        options: [{ label: "Yes", value: true }, { label: "No", value: false }],
        // className: "form-field fb-33"
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ],
        className: "form-field fb-20"
    },
    relationship_termination_notice_days: {
        label: "Termination Notice Days",
        type: INPUT_TYPES.NUMBER,
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ],
        className: "form-field fb-20"
    },
    facility_name: {
        label: "Facility Name",
        type: INPUT_TYPES.TEXT,
        defaultValue: "Flexiloan",
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ],
        className: "form-field fb-20"
    },
    can_buyer_raise_rff: {
        label: "Can Buyer Raise RFF ?",
        type: INPUT_TYPES.RADIO,
        options: [{ label: "Yes", value: true }, { label: "No", value: false }],
        // className: "form-field fb-33"
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ],
        className: "form-field fb-20"
    },
    can_seller_raise_rff: {
        label: "Can Seller Raise RFF ?",
        type: INPUT_TYPES.RADIO,
        options: [{ label: "Yes", value: true }, { label: "No", value: false }],
        // className: "form-field fb-33"
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ],
        className: "form-field fb-20"
    }
});

export const BUYER_QUALIFICATION_DETAILS_FORM = new OrderedMap({
    min_vintage_with_anchor_in_months: {
        label: "Minimum Vintage with Anchor (months)",
        placeholder: "Vintage",
        type: INPUT_TYPES.NUMBER,
        className: "form-field fb-15",
    },
    min_vintage_with_seller_in_months: {
        label: "Minimum Vintage with Seller (months)",
        placeholder: "Vintage",
        type: INPUT_TYPES.NUMBER,
        className: "form-field fb-15",
    },
    minimum_dependence_on_seller_perc: {
        label: "Minimum Dependence on Seller (%)",
        placeholder: "XXX",
        defaultValue: 0,
        type: INPUT_TYPES.FLOAT,
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ],
        className: "form-field fb-15",
    },
    minimum_dependence_on_anchor_perc: {
        label: "Minimum Dependence on Anchor (%)",
        placeholder: "XXX",
        defaultValue: 0,
        type: INPUT_TYPES.FLOAT,
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ],
        className: "form-field fb-15",
    },
    min_cibil_score: {
        label: "Minimum CIBIL Score",
        type: INPUT_TYPES.NUMBER,
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ],
        className: "form-field fb-10",
    }
});

export const BUSINESS_INTEREST_DETAILS = new OrderedMap({
    from_days: {
        label: "From Days",
        placeholder: "1",
        style: {
            width: "150px"
        },
        size: 150,
        type: INPUT_TYPES.NUMBER,
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ],
        className: "form-field fb-15"
    },
    to_days: {
        label: "To Days",
        placeholder: "1",
        style: {
            width: "150px"
        },
        size: 150,
        type: INPUT_TYPES.NUMBER,
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ],
        className: "form-field fb-15"
    },
    rate_of_interest: {
        label: "Rate of Interest",
        placeholder: "0.00",
        style: {
            width: "150px"
        },
        size: 150,
        type: INPUT_TYPES.FLOAT,
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ],
        className: "form-field fb-15"
    },
    interest_type: {
        label: "Interest Type",
        placeholder: "Interest Type",
        type: INPUT_TYPES.SELECT,
        options: PRODUCT_INTEREST_TYPES.map((_, k) => ({
            label: k,
            value: _
        })).toList(),
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ],
        className: "form-field fb-15"
    },
    interest_definition_type: {
        label: "Interest Definition Type",
        placeholder: "Interest Definition Type",
        type: INPUT_TYPES.SELECT,
        options: INTEREST_DEFINITION_TYPES.map((_, k) => ({
            label: k,
            value: _
        })).toList(),
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ],
        className: "form-field fb-15"
    }
});

export const BUSINESS_CASHBACK_DETAILS = new OrderedMap({
    buyer_share: {
        label: "Buyer Share",
        placeholder: "0.00",
        type: INPUT_TYPES.FLOAT,
        className: "form-field fb-20",
    },
    seller_share: {
        label: "Seller Share",
        placeholder: "0.00",
        type: INPUT_TYPES.FLOAT,
        className: "form-field fb-20",
    }
});

export const BUSINESS_PROGRAM_FEE = new OrderedMap({
    fee_type: {
        label: "Fee Type",
        placeholder: "Fee Type",
        type: INPUT_TYPES.SELECT,
        options: PRODUCT_FEE_TYPES.map((_, k) => ({
            label: k,
            value: _
        })).toList(),
        style: {
            width: "150px"
        },
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ],
        className: "form-field fb-15"
    },
    limit_range_start: {
        label: "Limit Range Start",
        placeholder: "0.00",
        type: INPUT_TYPES.FLOAT,
        style: {
            width: "150px"
        },
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ],
        className: "form-field fb-15",
    },
    limit_range_end: {
        label: "Limit Range End",
        placeholder: "0.00",
        type: INPUT_TYPES.FLOAT,
        style: {
            width: "150px"
        },
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ],
        className: "form-field fb-15",
    },
    fee_calculation_type: {
        label: "Fee Calculation Type",
        placeholder: "Fee Calculation Type",
        type: INPUT_TYPES.SELECT,
        options: FEE_CALCULATION_TYPES.map((_, k) => ({
            label: k,
            value: _
        })).toList(),
        style: {
            width: "175px"
        },
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ],
        className: "form-field fb-15",
    },
    amount_or_percentage: {
        label: "Fee Value",
        placeholder: "0.00",
        style: {
            width: "150px"
        },
        type: INPUT_TYPES.FLOAT,
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ],
        className: "form-field fb-15",
    },
    fee_debit_at: {
        label: "Fee Debit At",
        placeholder: "Fee Debit At",
        type: INPUT_TYPES.SELECT,
        mode: "multiple",
        options: FEE_DEBIT_AT_TYPES.map((_, k) => ({
            label: k,
            value: _
        })).toList(),
        style: {
            width: "150px"
        },
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ],
        className: "form-field fb-15",
    }
});

export const BUSINESS_FACILITY_DETAILS = new OrderedMap({
    due_date_from_type: {
        label: "Due Date Calculated From",
        placeholder: "Select",
        type: INPUT_TYPES.SELECT,
        options: DUE_DATE_FROM_TYPES.map((_, k) => ({
            label: k,
            value: _
        })).toList(),
        style: {
            width: "150px"
        },
        className: "form-field fb-12",
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ]
    },
    disbursal_wait_days: {
        label: "Disbursal Wait Days",
        placeholder: "0",
        type: INPUT_TYPES.NUMBER,
        // style: {
        //     width: "150px"
        // },
        className: "form-field fb-12",
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ]
    },
    max_tenor: {
        label: "Maximum Tenor",
        placeholder: "0",
        type: INPUT_TYPES.NUMBER,
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ],
        className: "form-field fb-10",
    },
    grace_period_days: {
        label: "Grace Period Days",
        type: INPUT_TYPES.NUMBER,
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ],
        className: "form-field fb-12",
    },
    hold_back_percentage: {
        label: "Holdback Percentage",
        placeholder: "XX",
        type: INPUT_TYPES.FLOAT,
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ],
        className: "form-field fb-12",
    },
    interest_subvention_percentage: {
        label: "Interest Subvention Percentage",
        type: INPUT_TYPES.FLOAT,
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ],
        className: "form-field fb-15",
    },
    product_lines: {
        label: "Product Lines List",
        placeholder: "Product Lines",
        type: INPUT_TYPES.OBJECT_SELECT,
        className: "form-field fb-10",
        style: {
            width: "120px"
        },
        mode: "multiple",
        showSearch: true,
        labelProp: "name",
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ],
        options: [],
    }
});

export const BUSINESS_PROGRAM_RECOURSE_DETAILS = new OrderedMap({
    account_block_days: {
        label: "Account Block Days",
        type: INPUT_TYPES.NUMBER,
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ],
        className: "form-field fb-20",
    },
    stop_billing_days: {
        label: "Stop Billing Days",
        type: INPUT_TYPES.NUMBER,
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ],
        className: "form-field fb-20",
    },
    stock_take_back_days: {
        label: "Stock Take Back Days",
        placeholder: "0",
        type: INPUT_TYPES.NUMBER,
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ],
        className: "form-field fb-20",
    },
    cheque_bank_days: {
        label: "Cheque Bank Days",
        type: INPUT_TYPES.NUMBER,
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ],
        className: "form-field fb-20",
    },
    overdue_settlement_notice_days: {
        label: "Overdue Settlement Notice Days",
        placeholder: "XX",
        type: INPUT_TYPES.NUMBER,
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ],
        className: "form-field fb-20",
    },
    hold_back_amount_use_days: {
        label: "Holdback Amount Use Days",
        type: INPUT_TYPES.NUMBER,
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ],
        className: "form-field fb-20",
    }
});


export const AGREEMENT_DETAILS_FORM = new OrderedMap({
    signing_date: {
        label: "Agreement Signing Date",
        type: INPUT_TYPES.DATE,
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ],
        className: "form-field fb-20"
    },
    start_date: {
        label: "Agreement Start Date",
        type: INPUT_TYPES.DATE,
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ],
        className: "form-field fb-20"
    },
    end_date: {
        label: "Agreement End Date",
        type: INPUT_TYPES.DATE,
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ],
        className: "form-field fb-20"
    }
});

export const PRE_APPROVAL_ATTACHMENT_FORM = new OrderedMap({
    credit_note: {
        className: "form-field fb-20",
        label: "Credit Note",
        btnLabel: "Credit Note",
        showUploadList: false,
        type: INPUT_TYPES.FILE
    },
    name_clearance: {
        className: "form-field fb-20",
        label: "Name Clearance",
        btnLabel: "Name Clearance",
        showUploadList: false,
        type: INPUT_TYPES.FILE
    }
});

export const POST_APPROVAL_ATTACHMENT_FORM = new OrderedMap({
    buyer_finance_agreements: {
        className: "form-field fb-20",
        label: "Buyer Finance",
        btnLabel: "Buyer Finance",
        showUploadList: false,
        type: INPUT_TYPES.FILE,
        rules: [
            {
                required: true,
                message: "Document Required"
            }
        ]
    },
    guarantor_agreement: {
        className: "form-field fb-20",
        label: "Guarantor Agreement",
        btnLabel: "Guarantor Agreement",
        showUploadList: false,
        type: INPUT_TYPES.FILE,
        rules: [
            {
                required: true,
                message: "Document Required"
            }
        ]
    }
});

export const DOCUMENT_CHECKLIST_CREATOR_FORM = new OrderedMap({
    entity: {
        label: "Entity",
        key: "entity",
        type: INPUT_TYPES.SELECT,
        options: []
    },
    product: {
        label: "Product",
        key: "product",
        type: INPUT_TYPES.SELECT,
        options: []
    },
    type: {
        label: "Type",
        key: "type",
        type: INPUT_TYPES.SELECT,
        options: []
    },
    bank: {
        label: "Bank",
        key: "bank",
        type: INPUT_TYPES.SELECT,
        options: []
    }
});

export const DOCUMENT_CATEGORY_FORM = new OrderedMap({
    document_category: {
        label: "Document Category",
        type: INPUT_TYPES.OBJECT_SELECT,
        options: [],
        key: "document_category"
    },
    document: {
        label: "Select Document",
        type: INPUT_TYPES.OBJECT_SELECT,
        key: "documents",
        options: []
    }
});

export const DOCUMENT_FILTERS_FORM = new OrderedMap({
    field_name: {
        label: "Field Name",
        type: INPUT_TYPES.SELECT,
        options: []
    },
    filter_type: {
        label: "Filter type",
        type: INPUT_TYPES.SELECT,
        options: []
    },
    operator: {
        label: "Select Operator",
        type: INPUT_TYPES.SELECT,
        options: []
    },
    value: {
        label: "Enter Filter Value",
        type: null,
        options: []
    }
});

export const COMPANY_DETAIL_FORMS = new OrderedMap({
    row1: new OrderedMap({
        gstin: {
            className: "form-field fb-20",
            label: "GSTIN",
            type: INPUT_TYPES.TEXT,
            placeholder: "29ABCDE1234F2Z2",
            hasFeedback: true
        },
        pan: {
            className: "form-field fb-20",
            label: "PAN",
            type: INPUT_TYPES.TEXT,
            placeholder: "ABCDE1234F",
            rules: [
                {
                    required: true,
                    message: "PAN is required"
                },
                {
                    max: 10,
                    message: "Please Enter a valid PAN No"
                },
                {
                    pattern: "[A-Z]{5}[0-9]{4}[A-Z]{1}",
                    message: "Please Enter a valid PAN No"
                }
            ],
            hasFeedback: true
        },
        company_name: {
            className: "form-field fb-20",
            label: "Company Legal Name",
            type: INPUT_TYPES.TEXT,
            rules: [
                {
                    required: true,
                    message: "Company Legal Name is Required"
                }
            ]
        },
        industry_type: {
            className: "form-field fb-20",
            label: "Industry Type",
            type: INPUT_TYPES.SELECT,
            options: INDUSTRY_CATEGORY_TYPES.map((_, k) => ({
                label: k,
                value: _
            })).toList(),
        }
    }),
    row2: new OrderedMap({
        address_line_1: {
            className: "form-field",
            label: "Address Line 1",
            icon: "address",
            placeholder: "House No., Building",
            type: INPUT_TYPES.TEXT
        },
        address_line_2: {
            className: "form-field",
            label: "Address Line 2",
            icon: "address",
            placeholder: "Street, Area",
            type: INPUT_TYPES.TEXT
        },
        pincode: {
            className: "form-field",
            label: "Pincode",
            placeholder: "123000",
            type: INPUT_TYPES.TEXT,
            rules: [ 
                {
                    required: true,
                    message: "Field is mandatory"
                },
                {
                    //eslint-disable-next-line
                    pattern: "^[1-9][0-9]{5}$",
                    message: "Enter valid Pincode"
                }
            ]
        },
        city: {
            className: "form-field",
            label: "City",
            icon: "environment",
            placeholder: "Delhi",
            type: INPUT_TYPES.OBJECT_SELECT,
            labelProp: "name",
            showSearch: true,
            rules: [
                {
                    required: true,
                    message: "Field is mandatory"
                }
            ]
        },
        district: {
            className: "form-field",
            label: "District",
            icon: "environment",
            placeholder: "Delhi",
            type: INPUT_TYPES.OBJECT_SELECT,
            labelProp: "name",
            showSearch: true,
            rules: [
                {
                    required: true,
                    message: "Field is mandatory"
                }
            ]
        },
        state: {
            className: "form-field",
            label: "State",
            icon: "environment",
            placeholder: "Delhi",
            type: INPUT_TYPES.OBJECT_SELECT,
            showSearch: true,
            labelProp: "name",
            rules: [
                {
                    required: true,
                    message: "Field is mandatory"
                }
            ]
        },
    })
});

export const SPOC_DETAILS_FORM = new OrderedMap({
    first_name: {
        className: "form-field fb-20",
        label: "First Name",
        type: INPUT_TYPES.TEXT,
        rules: [
            {
                required: true,
                message: "Field is required"
            },
            {
                //eslint-disable-next-line
                pattern: /^[A-Za-z]+$/,
                message: "Enter valid Name"
            }
        ]
    },
    middle_name: {
        className: "form-field fb-20",
        label: "Middle Name",
        type: INPUT_TYPES.TEXT,
        rules:[
            {
                //eslint-disable-next-line
                pattern: /^[A-Za-z]+$/,
                message: "Enter valid Name"
            }
        ]
    },
    last_name: {
        className: "form-field fb-20",
        label: "Last Name",
        type: INPUT_TYPES.TEXT,
        rules: [
            {
                required: true,
                message: "Field is required"
            },
            {
                //eslint-disable-next-line
                pattern: /^[A-Za-z]+$/,
                message: "Enter valid Name"
            }
        ]
    },
    spoc_phone_no: {
        className: "form-field fb-20",
        label: "Phone Number",
        type: INPUT_TYPES.TEXT,
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ]
    },
    spoc_email: {
        className: "form-field fb-20",
        label: "Email",
        type: INPUT_TYPES.EMAIL,
        rules: [
            {
                required: true,
                message: "E-mail is Required"
            },
            {
                pattern: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                message: "Enter valid Email"
            }
        ]
    },
});

export const BORROWER_CASE_FORM_DETAILS = new OrderedMap({
    ledger_name: {
        className: "form-field fb-20",
        label: "Ledger Name",
        type: INPUT_TYPES.TEXT
    },
    channel_products: {
        className: "form-field fb-20",
        label: "Channel Products",
        type: INPUT_TYPES.OBJECT_SELECT,
        rules: [
            {
                required: true
            }
        ],
        labelProp: "name",
        mode: "multiple"
    },
    bank: {
        className: "form-field fb-20",
        label: "Lending Partner",
        type: INPUT_TYPES.OBJECT_SELECT,
        showSearch: true,
        labelProp: "name"
    },
    priority: {
        className: "form-field fb-20",
        label: "Priority",
        type: INPUT_TYPES.SELECT,
        options: CASE_PRIORITY_TYPES.map((_, k) => ({
            label: k,
            value: _
        })).toList(),
    },
    lead_type: {
        className: "form-field fb-20",
        label: "Lead Type",
        type: INPUT_TYPES.SELECT,
        options: CASE_LEAD_TYPES.map((_, k) => ({
            label: k,
            value: _
        })).toList(),
    },
    ledger_sync: {
        label: "Is Ledger Sync",
        className: "form-field fb-20",
        type: INPUT_TYPES.RADIO,
        defaultValue: false,
        options: [
            {
                key: "Yes",
                value: true,
                label: "Yes"
            },
            {
                key: "No",
                value: false,
                label: "No"
            }
        ]
    },
    proposed_limit: {
        className: "form-field fb-20",
        label: "Proposed Limit",
        type: INPUT_TYPES.FLOAT
    },
    ledger_file: {
        className: "form-field fb-20",
        label: "Ledger",
        btnLabel: "Upload Ledger",
        showUploadList: false,
        type: INPUT_TYPES.FILE
    }
});

export const MARKET_ANCHOR_DATA_FIELDS = new OrderedMap({
    total_sales_or_turnover_inr_cr: {
        className: "form-field fb-20",
        label: "Total Sales/Turnover (In CR)",
        type: INPUT_TYPES.FLOAT
    },
    perc_share_of_product_in_overall_sales: {
        className: "form-field fb-20",
        label: "Percentage Share of Product in Overall Sales",
        type: INPUT_TYPES.FLOAT
    },
    perc_share_through_distribution_channel: {
        className: "form-field fb-20",
        label: "Percentage Share through Distribution Channel",
        type: INPUT_TYPES.FLOAT
    },
    total_no_distributor: {
        className: "form-field fb-20",
        label: "Total Distributiors Number",
        type: INPUT_TYPES.NUMBER
    },
    total_no_retailers: {
        className: "form-field fb-20",
        label: "Total Number of Retailers",
        type: INPUT_TYPES.NUMBER
    },
    north: {
        className: "form-field fb-20",
        label: "North",
        type: INPUT_TYPES.FLOAT
    },
    south: {
        className: "form-field fb-20",
        label: "South",
        type: INPUT_TYPES.FLOAT
    },
    east: {
        className: "form-field fb-20",
        label: "East",
        type: INPUT_TYPES.FLOAT
    },
    west: {
        className: "form-field fb-20",
        label: "West",
        type: INPUT_TYPES.FLOAT
    },
    credit_period_offered_primary: {
        className: "form-field fb-20",
        label: "Credit Period Offered Primary",
        type: INPUT_TYPES.NUMBER
    },
    credit_period_offered_secondary: {
        className: "form-field fb-20",
        label: "Credit Period Offered Secondary",
        type: INPUT_TYPES.NUMBER
    },
    cd_policy_primary: {
        className: "form-field fb-20",
        label: "CD Policy Primary",
        type: INPUT_TYPES.FLOAT
    },
    cd_policy_secondary: {
        className: "form-field fb-20",
        label: "CD Policy Secondary",
        type: INPUT_TYPES.FLOAT
    },
    whether_channel_finance_is_there: {
        className: "form-field fb-20",
        label: "Whether Channel Finance is There",
        type: INPUT_TYPES.RADIO,
        options: [{ label: "Yes", value: true }, { label: "No", value: false }],
        // className: "form-field fb-33"
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ],
    },
    primary_inr_cr: {
        className: "form-field fb-20",
        label: "Primary (INR Cr)",
        type: INPUT_TYPES.FLOAT
    },
    secondary_inr_cr: {
        className: "form-field fb-20",
        label: "Secondary (INR Cr)",
        type: INPUT_TYPES.FLOAT
    },
});

export const MARKET_DISTRIBUTOR_DATA_FIELDS = new OrderedMap({
    state: {
        className: "form-field fb-20",
        label: "State",
        type: INPUT_TYPES.OBJECT_SELECT,
        showSearch: true,
        labelProp: "name"
    },
    business_division: {
        className: "form-field fb-20",
        label: "Business Division",
        type: INPUT_TYPES.OBJECT_SELECT,
        labelProp: "name"
    },
    total_sales_or_turnover_inr_cr: {
        className: "form-field fb-20",
        label: "Total Sales/Turnover (In CR)",
        type: INPUT_TYPES.FLOAT
    },
    territory_managed_by_distributor: {
        className: "form-field fb-20",
        label: "Territory Managed by Distributor",
        type: INPUT_TYPES.NUMBER
    },
    retailer_or_sub_dealers_under_distribution: {
        className: "form-field fb-20",
        label: "Retailer or Sub Dealers under Distribution",
        type: INPUT_TYPES.NUMBER
    },
    distributor_sale_in_anchor_monthly_inr_cr: {
        className: "form-field fb-20",
        label: "Distributor Monthly Sales in Anchor (INR Cr)",
        type: INPUT_TYPES.FLOAT
    },
    distributor_sale_in_anchor_yearly_inr_cr: {
        className: "form-field fb-20",
        label: "Distributor Yearly Sales in Anchor (INR Cr)",
        type: INPUT_TYPES.FLOAT
    },
    brands_dealing_in: {
        className: "form-field fb-20",
        label: "Brands Dealing In",
        type: INPUT_TYPES.FLOAT
    },
    no_of_brands_handled_by_distributor: {
        className: "form-field fb-20",
        label: "Number of Brands Handled by Distributor",
        type: INPUT_TYPES.FLOAT
    },
    name_of_brands_handled_by_distributor: {
        className: "form-field fb-20",
        label: "Name of Brands Handled by Distributor",
        type: INPUT_TYPES.TEXT
    },
    region_categorization: {
        className: "form-field fb-20",
        label: "Region Categorization",
        type: INPUT_TYPES.FLOAT
    },
    credit_period_offered_by_distributor_days: {
        className: "form-field fb-20",
        label: "Credit Period Offerred by Distributor",
        type: INPUT_TYPES.FLOAT
    },
    any_overdue_gt_60_in_last_12_months: {
        className: "form-field fb-20",
        label: "Any Overdue > 60 in last 12 Months",
        type: INPUT_TYPES.RADIO,
        options: [{ label: "Yes", value: true }, { label: "No", value: false }],
        // className: "form-field fb-33"
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ],
    },
    remarks_of_distributor: {
        className: "form-field fb-20",
        label: "Remarks of Distributor",
        type: INPUT_TYPES.TEXT
    }
});

export const REGION_DETAILS_FORM_FIELDS = new OrderedMap({
    region_name: {
        type: INPUT_TYPES.TEXT,
        label: "Region Name",
        className: "form-field fb-20"
    },
    relationship_manager_id: {
        type: INPUT_TYPES.OBJECT_SELECT,
        label: "Relationship Manager",
        className: "form-field fb-20",
        labelProp: "full_name",
        // options: []
    }
});

export const REGION_ASSOCIATES_FORM_FIELDS = new OrderedMap({
    first_name: {
        type: INPUT_TYPES.TEXT,
        label: "First Name",
        className: "form-field fb-20",
        rules: [
            {
                required: true,
                message: "First Name is Required"
            },
            {
                //eslint-disable-next-line
                pattern: /^[A-Za-z]+$/,
                message: "Enter valid Name"
            }
        ]
    },
    last_name: {
        type: INPUT_TYPES.TEXT,
        label: "Last Name",
        className: "form-field fb-20",
        rules: [
            {
                required: true,
                message: "Last Name is Required"
            },
            {
                //eslint-disable-next-line
                pattern: /^[A-Za-z]+$/,
                message: "Enter valid Name"
            }
        ]
    },
    email: {
        type: INPUT_TYPES.EMAIL,
        label: "Email",
        className: "form-field fb-20",
        rules:[
            {
                required: true,
                message: "E-mail is Required"
            },
            {
                pattern: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                message: "Enter valid Email"
            }
        ]
    },
    phone: {
        type: INPUT_TYPES.TEXT,
        label: "Phone",
        className: "form-field fb-20",
        rules: [
            {
                required: true,
                message: "Mobile Number is Required"
            },
            {
                min: 10,
                message: "Enter valid mobile number "
            },
            {
                max: 10,
                message: "Enter valid mobile number "
            },
            {
                pattern: /^(?:\d*)$/,
                message: "Value should contain just number",
            },
        ]
    }
});

export const FACILITY_ACCOUNT_FIELDS = (fieldValidator) => new OrderedMap({
    row1: new OrderedMap({
        agreement_id: {
            label: "Agreement Number",
            placeholder: "XXXX",
            className: "form-field fb-20",
            type: INPUT_TYPES.TEXT
        },
        sanction_date: {
            rules: [
                { required: true, message: "Please select a date" },
                fieldValidator
            ],
            label: "Sanction Date",
            placeholder: "dd-mm-yyyy",
            type: INPUT_TYPES.DATE,
            className: "form-field fb-20"
        },
        agreement_tenor: {
            label: "Agreement Tenor (in Months)",
            placeholder: "XX",
            type: INPUT_TYPES.NUMBER,
            rules: [
                {
                    required: true
                },
                fieldValidator
            ],
            className: "form-field fb-20"
        },
        agreement_end_date: {
            rules: [
                { required: true, message: "Please select a date" },
                fieldValidator
            ],
            label: "Agreement End Date",
            placeholder: "dd-mm-yyyy",
            type: INPUT_TYPES.DATE,
            className: "form-field fb-20"
        },
        // disbural_account: {
        //     label: "Disbursal Account",
        //     placeholder: "XX",
        //     type: INPUT_TYPES.OBJECT_SELECT,
        //     rules: [
        //         {
        //             required: true
        //         },
        //         fieldValidator
        //     ],
        //     className: "form-field fb-20"
        // },
        // collection_account: {
        //     rules: [
        //         { required: true, message: "Please select a Collection Account" },
        //         fieldValidator
        //     ],
        //     label: "Collection Account",
        //     placeholder: "XXX",
        //     type: INPUT_TYPES.OBJECT_SELECT,
        //     className: "form-field fb-20"
        // },
        anchor_relationship_manager: {
            type: INPUT_TYPES.OBJECT_SELECT,
            label: "Anchor Relationship Manager",
            className: "form-field fb-20",
            labelProp: "name",
            mode: "multiple",
            options: []
        }
    }),
});

export const DISBURSED_FIELDS = new OrderedMap({
    current_outstanding: {
        label: "Current Outstanding",
        placeholder: "XXXX",
        type: INPUT_TYPES.FLOAT,
        className: "form-field fb-20"
    },
    total_throughput: {
        label: "Total Throughput",
        placeholder: "XXXX",
        type: INPUT_TYPES.FLOAT,
        className: "form-field fb-20"
    },
    sanction_limit: {
        label: "Sanction Limit",
        placeholder: "XXXX",
        type: INPUT_TYPES.FLOAT,
        className: "form-field fb-20"
    },
    loaded_limit: {
        label: "Loaded Limit",
        placeholder: "XXXX",
        type: INPUT_TYPES.FLOAT,
        className: "form-field fb-20"
    },
    total_paid: {
        label: "Total Paid",
        placeholder: "XXXX",
        type: INPUT_TYPES.FLOAT,
        className: "form-field fb-20"
    },
    withhold_amount: {
        label: "Withhold Amount",
        placeholder: "XXXX",
        type: INPUT_TYPES.FLOAT,
        className: "form-field fb-20"
    },
    withhold_amount_released: {
        label: "Withhold Amount Released",
        placeholder: "XXXX",
        type: INPUT_TYPES.FLOAT,
        className: "form-field fb-20"
    },
    subvention_amount: {
        label: "Subvention Amount",
        placeholder: "XXXX",
        type: INPUT_TYPES.FLOAT,
        className: "form-field fb-20"
    },
});

export const UPLOAD_LEDGER_FORM = new OrderedMap({
    anchor: {
        label: "Anchor",
        type: INPUT_TYPES.OBJECT_SELECT,
        className: "form-field fb-20",
        placeholder: "Select Anchor",
        labelProp: "name",
        showSearch: true,
        autoClearSearchValue: false,
        style: {
            maxWidth: 250
        },
        getPopupContainer: true
    },
    seller: {
        label: "Seller",
        type: INPUT_TYPES.OBJECT_SELECT,
        notFoundContent: "This Seller doesn't exist, you need to create it.",
        className: "form-field fb-20",
        placeholder: "Select Seller",
        labelProp: "name",
        showSearch: true,
        autoClearSearchValue: false,
        style: {
            maxWidth: 250
        }
    },
    ledger_file: {
        className: "form-field fb-20",
        label: "Ledger File",
        btnLabel: "Ledger File",
        showUploadList: false,
        type: INPUT_TYPES.FILE,
        style: {
            maxWidth: 250
        }
    }
});

export const ADD_PRODUCT_FIELDS = new OrderedMap({
    name: {
        className: "form-field",
        label: "Name",
        type: INPUT_TYPES.TEXT
    },
    short_name: {
        className: "form-field",
        label: "Short Name",
        type: INPUT_TYPES.TEXT
    }
});

export const INPUTS = new OrderedMap({
    LABEL: {
        type: "LABEL"
    },
    MULTI_TEXT: {
        type: INPUT_TYPES.SELECT,
        mode: "tags",
        options: []
    },
    MULTI_SELECT: {
        type: INPUT_TYPES.SELECT,
        mode: "multiple",
        options: []
    },
    TEXT: {
        type: INPUT_TYPES.TEXT
    },
    AMOUNT: {
        type: INPUT_TYPES.FLOAT
    },
    DATE: {
        type: INPUT_TYPES.DATE
    },
    OBJECT_TEXT: {
        type: INPUT_TYPES.OBJECT_TEXT
    },
    RADIO: {
        type: INPUT_TYPES.RADIO
    },
    SELECT: {
        type: INPUT_TYPES.SELECT
    },
    NUMBER: {
        type: INPUT_TYPES.NUMBER
    },
    TEXTAREA: {
        type: INPUT_TYPES.TEXTAREA,
        row: "4"
    },
    IMAGES: {
        type: INPUT_TYPES.TILES,
        showUploadList: false,
    }
});

export const PDFIELDS = new OrderedMap({
    documentType: {
        type: INPUT_TYPES.SELECT,
        options: [],
        label: "Select Document Type",
        style: {
            maxWidth: 250
        }
    },
    document: {
        className: "form-field fb-20",
        label: "Upload Document",
        btnLabel: "Upload",
        showUploadList: false,
        multiple: true,
        mode: "multiple",
        type: INPUT_TYPES.FILE,
        style: {
            maxWidth: 250
        }
    }
});

export const PD_BRANDS_TABLE_FIELDS = new OrderedMap({
    Brand_Name: {
        className: "form-field fb-20",
        label: "Brand Name",
        type: INPUT_TYPES.TEXT
    },
    Distributor_Name: {
        className: "form-field fb-20",
        label: "Distributor Name",
        type: INPUT_TYPES.TEXT
    },
    Percent_Sale: {
        className: "form-field fb-20",
        label: "Percent Sale",
        type: INPUT_TYPES.TEXT
    }
});

export const PD_BANK_DETAILS_TABLE_FIELDS = new OrderedMap({
    Account_Number: {
        className: "form-field fb-20",
        label: "Account Number",
        type: INPUT_TYPES.NUMBER
    },
    IFSC_Code: {
        className: "form-field fb-20",
        label: "IFSC Code",
        type: INPUT_TYPES.TEXT
    }
});

export const BANK_STATEMENT_ANALYSIS_FORM = new OrderedMap({
    files: {
        key: "files",
        multiple: true,
        action: null,
        showUploadList: false,
        label: "Upload Ledgers",
        type: INPUT_TYPES.DRAGGABLEUPLOADER,
        className: "form-field multiple-file",
        title: "Upload Files",
        category: 4,
        rules: [{
            required: true,
        }]
    },
    bank_id: {
        key: "bank_id",
        type: INPUT_TYPES.SELECT,
        options: [],
        label: "Bank Name",
        rules: [{
            required: true
        }],
        showSearch: true,
        filterOption: (value, option) => {
            if (value) {
                return (
                    option.props.label && option.props.label.toLocaleLowerCase().includes(value.toLocaleLowerCase())
                );
            }
            return true;
        },
        optionFilterProp: "label",
        optionLabelProp: "label",
    },
    account_type: {
        key: "account_type",
        type: INPUT_TYPES.SELECT,
        options: [],
        label: "Account Type",
        rules: [{
            required: true
        }],
        filterOption: (value, option) => {
            if (value) {
                return (
                    option.props.label && option.props.label.toLocaleLowerCase().includes(value.toLocaleLowerCase())
                );
            }
            return true;
        },
        showSearch: true,
        optionFilterProp: "label",
        optionLabelProp: "label",
    },
    from_date: {
        className: "form-field fb-50",
        key: "from_date",
        type: INPUT_TYPES.DATE_MONTH,
        options: [],
        label: "From Date",
        rules: [
            {
                required: true,
                message: "From Date is required"
            }
        ],
        disabledDate: (current) => {
            const today = moment().endOf('month');
            const last12Months = moment().subtract(12, 'months').startOf('month');    
            return current && (current > today || current < last12Months);
        }
    },
    to_date: {
        className: "form-field fb-50",
        key: "to_date",
        type: INPUT_TYPES.DATE_MONTH,
        options: [],
        label: "To Date",
        rules: [
            {
                required: true,
                message: "To date is required"
            }
        ],
        disabledDate: (current) => {
            const today = moment().endOf('month');
            const last12Months = moment().subtract(12, 'months').startOf('month');    
            return current && (current > today || current < last12Months);
        }
    },
    password_protected: {
        key: "password_protected",
        label: "Password Protected",
        type: INPUT_TYPES.RADIO,
        defaultValue: "no",
        options: [
            {
                key: "yes",
                value: "yes",
                label: "Yes"
            },
            {
                key: "no",
                value: "no",
                label: "No"
            }
        ],
        rules: [
            {
                required: true,
                message: "Field is required"
            },
            
        ]
    },
    password: {
        key: "password",
        label: "Password",
        type: INPUT_TYPES.PASSWORD
    }
});

export const BANK_STATEMENT_MANNUAL_FINNOV_ANALYSIS_FORM = new OrderedMap({
    application_id: {
        label: "Analysis ID",
        type: INPUT_TYPES.TEXT,
        rules: [{
            required: true,
        }]
    },
    account_type: {
        key: "account_type",
        type: INPUT_TYPES.SELECT,
        options: [],
        label: "Account Type",
        rules: [{
            required: true
        }],
        filterOption: (value, option) => {
            if (value) {
                return (
                    option.props.label && option.props.label.toLocaleLowerCase().includes(value.toLocaleLowerCase())
                );
            }
            return true;
        },
        showSearch: true,
        optionFilterProp: "label",
        optionLabelProp: "label",
    }
});

export const SINGLE_ADHOC_FORM_FIELDS = new OrderedMap({
    bank_code: {
        key: "bank_code",
        type: INPUT_TYPES.SELECT,
        options: [],
        label: "Select Bank Code",
        style: {
            width: "250px"
        }
    },
    proposed_limit: {
        key: "Proposed Limit",
        type: INPUT_TYPES.FLOAT,
        label: "Proposed Limit",
        style: {
            width: "250px"
        }
    }
});

export const SLAB_FORM_FIELDS = new OrderedMap({

    slab_from_amount: {
        key: "from_amount",
        label: "From (in Crs)",
        dataIndex: "from_amount",
        type: INPUT_TYPES.NUMBER,
        className: "form-fiel fb-20 mr-3 perc",
        rules: [
            {
                required: true,
                message: "Field is required"
            },
        ]
    },
    slab_to_amount: {
        key: "to_amount",
        label: "To (in Crs)",
        dataIndex: "to_amount",
        type: INPUT_TYPES.NUMBER,
        className: "form-field fb-30 mr-3perc",
        rules: [
            {
                required: true,
                message: "Field is required"
            },
            
        ]
    },
    slab_fee_type: {
        label: "Fee Type",
        className: "form-field fb-30 mr-3perc",
        type: INPUT_TYPES.RADIO,
        defaultValue: 1,
        options: [
            {
                key: "Fixed",
                value: 1,
                label: "Fixed"
            },
            {
                key: "Percentage",
                value: 2,
                label: "Percentage"
            }
        ],
        rules: [
            {
                required: true,
                message: "Field is required"
            },
            
        ]
    },
    slab_fee_amount: {
        disabled: true,
        key: "slab_fee_amount",
        label: "Amount",
        dataIndex: "slab_fee_amount",
        type: INPUT_TYPES.NUMBER,
        className: "form-field fb-30 mr-3perc",
        rules: [
            {
                required: true,
                message: "Field is required"
            },
            
        ]
    },
    slab_fee_perc: {
        disabled: true,
        key: "slab_fee_perc",
        label: "Percentage",
        dataIndex: "slab_fee_perc",
        type: INPUT_TYPES.NUMBER,
        className: "form-field fb-30 mr-3perc",
        rules: [
            {
                required: true,
                message: "Field is required"
            },
            
        ]
    },
});

export const ANCHOR_FEES_FIELDS = new OrderedMap({
    fee_basis: {
        className: "form-field fb-30 mr-3perc",
        type: INPUT_TYPES.SELECT,
        label: "Fee Basis",
        rules: [
            {
                required: true,
                message: "Field is Required"
            }
        ],
        options: FEE_BASIS_TYPE.map((value, label) => ({ value, label })).toList().toArray(),
        col : 8
    },
    charges_at: {
        className: "form-field fb-30 mr-3perc",
        type: INPUT_TYPES.SELECT,
        label: "Charges At",
        rules: [
            {
                required: true,
                message: "Field is Required"
            }
        ],
        options: CHARGES_AT_TYPE.map((value, label) => ({ value, label })).toList().toArray(),
        col : 8
    },
    payment_frequency: {
        className: "form-field fb-30 mr-3perc",
        type: INPUT_TYPES.SELECT,
        label: "Payment Frequency",
        rules: [
            {
                required: true,
                message: "Field is Required"
            }
        ],
        options: PAYMEN_FREQUENCY_TYPE.map((value, label) => ({ value, label })).toList().toArray(),
        col : 8
    },
    is_slab_based: {
        label: "Slab Based",
        className: "form-field fb-20 mr-3perc",
        type: INPUT_TYPES.RADIO,
        // defaultValue: false,
        options: [
            {
                key: true,
                value: true,
                label: "Yes"
            },
            {
                key: false,
                value: false,
                label: "No"
            }
        ],
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ],
        col : 8

    },
    add_slab: {
        className: "form-field",
        type: INPUT_TYPES.BUTTON,
        btnType: "link",
        placeholder: "+ Add Slab",
        col: 8
    },
    fee_type: {
        label: "Fee Type",
        className: "form-field fb-20 mr-3perc",
        type: INPUT_TYPES.RADIO,
        // defaultValue: "1",
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ],
        options: [
            {
                key: "Fixed",
                value: 1,
                label: "Fixed"
            },
            {
                key: "Percentage",
                value: 2,
                label: "Percentage"
            }
        ],
        col : 24
    },
    fee_amount: {
        disabled: true,
        key: "fee_amount",
        label: "Amount",
        dataIndex: "fee_amount",
        type: INPUT_TYPES.NUMBER,
        className: "form-fiel fb-20 mr-3perc",
        col : 8,
        rules: [
            {
                required: true,
                message: "Field is Required"
            }
        ],
    },
    fee_perc: {
        disabled: true,
        key: "fee_perc",
        label: "Percentage",
        dataIndex: "fee_perc",
        type: INPUT_TYPES.NUMBER,
        className: "fb-20 mr-3perc",
        col : 14,
        rules: [
            {
                required: true,
                message: "Field is Required"
            },
            {
                pattern: /^(100(\.0{1,2})?|\d{1,2}(\.\d{1,2})?|0(\.\d{1,2})?)$/,
                message: "Input must be between 0 and 100"
            }
        ],
    },
    
});

export const COMPANY_BACKGROUND_FIELDS = new OrderedMap({
    industry: {
        disabled: true,
        key: "industry",
        label: "Industry",
        dataIndex: "industry",
        type: INPUT_TYPES.TEXT,
        className: "form-fiel fb-20 mr-3perc",
        col : 8,
        // rules: [
        //     {
        //         required: true,
        //         message: "Field is Required"
        //     }
        // ],
    },
    sector: {
        disabled: false,
        key: "sector",
        label: "Sector",
        dataIndex: "sector",
        type: INPUT_TYPES.TEXT,
        className: "form-fiel fb-20 mr-3perc",
        col : 8,
        rules: [
            {
                required: true,
                message: "Field is Required"
            }
        ],
    },
    date_of_incorporation: {
        disabled: false,
        key: "date_of_incorporation",
        label: "Date of incorporation",
        dataIndex: "date_of_incorporation",
        type: INPUT_TYPES.DATE,
        className: "form-fiel fb-20 mr-3perc",
        col : 8,
        rules: [
            {
                required: true,
                message: "Field is Required"
            }
        ],
        disabledDate: (current) => {
            // Disable dates from today onwards
            return current && current > moment().endOf('day');
        }
    },
    market_presence: {
        disabled: false,
        key: "market_presence",
        label: "Market Presence",
        dataIndex: "market_presence",
        type: INPUT_TYPES.TEXT,
        className: "form-fiel fb-20 mr-3perc",
        col : 8,
        rules: [
            {
                required: true,
                message: "Field is Required"
            }
        ],
    },
    company_locations: {
        disabled: false,
        key: "company_locations",
        label: "Manufacturing/Company Locations",
        dataIndex: "company_locations",
        type: INPUT_TYPES.TEXT,
        className: "form-fiel fb-20 mr-3perc",
        col : 24,
        rules: [
            {
                required: true,
                message: "Field is Required"
            }
        ],
    },
    product_lines: {
        disabled: false,
        key: "product_lines",
        label: "product Lines",
        dataIndex: "product_lines",
        type: INPUT_TYPES.TEXT,
        className: "form-fiel fb-20 mr-3perc",
        col : 12,
        rules: [
            {
                required: true,
                message: "Field is Required"
            }
        ],
    },
    other_details: {
        disabled: false,
        key: "other_details",
        label: "Other Details (Optional)",
        dataIndex: "other_details",
        type: INPUT_TYPES.TEXT,
        className: "form-fiel fb-20 mr-3perc",
        col : 12,
    },
    distribution_network: {
        disabled: false,
        key: "distribution_network",
        label: "Distribution Network",
        dataIndex: "distribution_network",
        type: INPUT_TYPES.TEXT,
        className: "form-fiel fb-20 mr-3perc",
        col : 12,
        rules: [
            {
                required: true,
                message: "Field is Required"
            }
        ],
    },
    website: {
        disabled: false,
        key: "website",
        label: "Website (Optional)",
        dataIndex: "website",
        type: INPUT_TYPES.TEXT,
        className: "form-fiel fb-20 mr-3perc",
        col : 12,
    },
    is_top_5_player_in_the_market: {
        disabled: false,
        key: "is_top_5_player_in_the_market",
        label: "Top 5 Player in the Market?",
        dataIndex: "is_top_5_player_in_the_market",
        type: INPUT_TYPES.RADIO,
        className: "fb-20 mr-3perc",
        col : 24,
        options: [
            {
                key: "yes",
                value: true,
                label: "Yes"
            },
            {
                key: "no",
                value: false,
                label: "No"
            }
        ],
    },
    perc_market_share_details: {
        disabled: false,
        key: "perc_market_share_details",
        label: "% Market Share Details (Optional)",
        dataIndex: "perc_market_share_details",
        type: INPUT_TYPES.TEXT,
        className: "fb-20 mr-3perc",
        col : 24,
    },
    promoter_investor_background: {
        disabled: false,
        key: "promoter_investor_background",
        label: "Promoter/Investor Background",
        dataIndex: "promoter_investor_background",
        type: INPUT_TYPES.TEXT,
        className: "fb-20 mr-3perc",
        col : 24,
        rules: [
            {
                required: true,
                message: "Field is Required"
            },
        ],
    },
    cash_surplus_duration_month: {
        disabled: false,
        key: "cash_surplus_duration_month",
        label: "Cash Surplus Duration",
        dataIndex: "cash_surplus_duration_month",
        type: INPUT_TYPES.NUMBER,
        className: "fb-20 mr-3perc",
        col : 8,
        rules: [
            {
                required: true,
                message: "Field is Required"
            },
            {
                pattern: /^(?:\d*\.)?\d+$/,
                message: "Please enter a number"
            }
        ],
    },
    // cash_surplus_amount: {
    //     disabled: false,
    //     key: "cash_surplus_amount",
    //     label: "Cash Surplus Value",
    //     dataIndex: "cash_surplus_amount",
    //     type: INPUT_TYPES.TEXT,
    //     className: "fb-20 mr-3perc",
    //     col : 8,
    //     rules: [
    //         {
    //             required: true,
    //             message: "Field is Required"
    //         },
    //     ],
    // },
    // series_funded: {
    //     disabled: false,
    //     key: "series_funded",
    //     label: "Series Funded",
    //     dataIndex: "series_funded",
    //     type: INPUT_TYPES.SELECT,
    //     className: "fb-20 mr-3perc",
    //     col : 8,
    //     // rules: [
    //     //     {
    //     //         required: true,
    //     //         message: "Field is Required"
    //     //     },
    //     // ],
    //     options: SERIES_FUNDED.map((value, label) => ({ value, label })).toList().toArray(),
    // },
    market_feedback_1_person_name: {
        disabled: false,
        key: "market_feedback_1_person_name",
        label: "Name of the Person Advocating",
        dataIndex: "market_feedback_1_person_name",
        type: INPUT_TYPES.TEXT,
        className: "fb-20 mr-3perc",
        col : 8,
        rules: [
            {
                required: true,
                message: "Field is Required"
            },
        ],
    },
    market_feedback_1_company_name: {
        disabled: false,
        key: "market_feedback_1_company_name",
        label: "Name of the company",
        dataIndex: "market_feedback_1_company_name",
        type: INPUT_TYPES.TEXT,
        className: "fb-20 mr-3perc",
        col : 8,
        rules: [
            {
                required: true,
                message: "Field is Required"
            },
        ],
    },
    market_feedback_1_remarks: {
        disabled: false,
        key: "market_feedback_1_remarks",
        label: "Remarks",
        dataIndex: "market_feedback_1_remarks",
        type: INPUT_TYPES.TEXT,
        className: "fb-20 mr-3perc",
        col : 8,
        rules: [
            {
                required: true,
                message: "Field is Required"
            },
        ],
    },
    market_feedback_2_person_name: {
        disabled: false,
        key: "market_feedback_2_person_name",
        label: "Name of the Person Advocating",
        dataIndex: "market_feedback_2_person_name",
        type: INPUT_TYPES.TEXT,
        className: "fb-20 mr-3perc",
        col : 8,
        rules: [
            {
                required: true,
                message: "Field is Required"
            },
        ],
    },
    market_feedback_2_company_name: {
        disabled: false,
        key: "market_feedback_2_company_name",
        label: "Name of the company",
        dataIndex: "market_feedback_2_company_name",
        type: INPUT_TYPES.TEXT,
        className: "fb-20 mr-3perc",
        col : 8,
        rules: [
            {
                required: true,
                message: "Field is Required"
            },
        ],
    },
    market_feedback_2_remarks: {
        disabled: false,
        key: "market_feedback_2_remarks",
        label: "Remarks",
        dataIndex: "market_feedback_2_remarks",
        type: INPUT_TYPES.TEXT,
        className: "fb-20 mr-3perc",
        col : 8,
        rules: [
            {
                required: true,
                message: "Field is Required"
            },
        ],
    },
});

export const COMPANY_FINANCIALS_FIELDS = new OrderedMap({
    ebitda: {
        disabled: false,
        key: "ebitda",
        label: "EBITDA(In Crs)",
        dataIndex: "ebitda",
        type: INPUT_TYPES.NUMBER,
        className: "form-fiel fb-20 mr-3perc",
        col : 8,
        rules: [
            {
                required: true,
                message: "Field is Required"
            }
        ],
    },
    tol_ratio: {
        disabled: false,
        key: "tol_ratio",
        label: "TOL/TNW",
        dataIndex: "tol_ratio",
        type: INPUT_TYPES.NUMBER,
        className: "form-fiel fb-20 mr-3perc",
        col : 8,
    },
    banking_other_channel_financiers: {
        disabled: false,
        key: "banking_other_channel_financiers",
        label: "Banking/Other Channel Financers",
        dataIndex: "banking_other_channel_financiers",
        type: INPUT_TYPES.TEXT,
        className: "form-fiel fb-20 mr-3perc",
        col : 8,
    },
    turnover_ytd: {
        disabled: false,
        key: "turnover_ytd",
        label: "Turnover YTD (In Crs)",
        dataIndex: "turnover_ytd",
        type: INPUT_TYPES.FLOAT,
        className: "form-fiel fb-20 mr-3perc",
        col : 12,
        rules: [
            {
                required: true,
                message: "Field is Required"
            }
        ],
    },
    credit_rating: {
        disabled: false,
        key: "credit_rating",
        label: "Credit Rating",
        dataIndex: "credit_rating",
        type: INPUT_TYPES.TEXT,
        className: "form-fiel fb-20 mr-3perc",
        col : 12,
    },
    commercial_cibil: {
        disabled: false,
        key: "commercial_cibil",
        label: "Commercial Cibil",
        dataIndex: "top_5_commercial_cibilplayer",
        type: INPUT_TYPES.TEXT,
        className: "fb-20 mr-3perc",
        col : 24,
        rules: [
            {
                required: true,
                message: "Field is Required"
            }
        ],
    },
});

export const ONBOARDING_CONTROLS_FIELDS = new OrderedMap({
    non_mandatory_documents_for_buyer: {
        className: "form-field fb-30 mr-3perc",
        label: "Document Waiver for Buyer",
        type: INPUT_TYPES.OBJECT_SELECT,
        // getOptionsOnFocus: getChannelProducts,
        labelProp: "document_name",
        options: [],
        mode: "multiple",
        filterOption: true,
        category: 1
    },
    non_mandatory_documents_for_seller: {
        className: "form-field fb-30 mr-3perc",
        label: "Document Waiver for Seller",
        type: INPUT_TYPES.OBJECT_SELECT,
        // getOptionsOnFocus: getChannelProducts,
        labelProp: "document_name",
        options: [],
        mode: "multiple",
        filterOption: true,
        category: 1
    },
    mandatory_documents_for_buyer: {
        className: "form-field fb-30 mr-3perc",
        label: "Buyer - Mandatory Documents",
        type: INPUT_TYPES.OBJECT_SELECT,
        // getOptionsOnFocus: getChannelProducts,
        labelProp: "document_name",
        options: [],
        mode: "multiple",
        filterOption: true,
        category: 1
    },


    retailer_risk_security_type: {
        className: "form-field fb-30 mr-3perc",
        type: INPUT_TYPES.SELECT,
        label: "Security Type",
        rules: [
            {
                required: true,
                message: "Security Type is Required"
            }
        ],
        options: SECURITY_TYPES.map((value, label) => ({ value, label })).toList().toArray(),

    },



    retailer_holdback_calculation_type: {
        label: "Holdback Type",
        className: "form-field fb-20 mr-3perc",
        type: INPUT_TYPES.RADIO,
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ],
        options: [
            {
                key: "security_perc",
                value: 2,
                label: "Holdback %"
            },
            {
                key: "security_amount",
                value: 1,
                label: "Holdback Amount"
            }
        ],
        col: 24
    },

    retailer_risk_holdback_perc: {
        key: "retailer_risk_holdback_perc",
        label: "Holdback %",
        dataIndex: "retailer_risk_holdback_perc",
        type: INPUT_TYPES.NUMBER,
        className: "form-field fb-30 mr-3perc",
        rules: [
            {
                required: true,
                message: "Field is required"
            },
            {
                pattern: /^(100(\.0{1,2})?|\d{1,2}(\.\d{1,2})?|0(\.\d{1,2})?)$/,
                message: "Input must be between 0 and 100"
            }
        ],
    },
    
    retailer_risk_security_amount: {
        key: "retailer_risk_security_amount",
        label: "Holdback Amount",
        dataIndex: "retailer_risk_security_amount",
        type: INPUT_TYPES.NUMBER,
        className: "form-field fb-30 mr-3perc",
        rules: [
            {
                required: true,
                message: "Field is required"
            },
            {
                pattern: /^(100(\.0{1,2})?|\d{1,2}(\.\d{1,2})?|0(\.\d{1,2})?)$/,
                message: "Input must be between 0 and 100"
            }
        ],
    },
   
    is_manual_ledger_allowed: {
        label: "Allow Manual Ledger?",
        className: "form-field fb-20 mr-3perc",
        type: INPUT_TYPES.RADIO,
        defaultValue: false,
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ],
        options: [
            {
                key: "Yes",
                value: true,
                label: "Yes"
            },
            {
                key: "No",
                value: false,
                label: "No"
            }
        ]
    },
    is_tiered_sbd_waiver_allowed: {
        label: "Allow Tiered SBD Waiver?",
        className: "form-field fb-20 mr-3perc",
        type: INPUT_TYPES.RADIO,
        defaultValue: false,
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ],
        options: [
            {
                key: "Yes",
                value: true,
                label: "Yes"
            },
            {
                key: "No",
                value: false,
                label: "No"
            }
        ]
    },
    maximum_days_of_limit_calculation: {
        key: "maximum_days_of_limit_calculation",
        label: "Maximum Days for Limit Calculation",
        dataIndex: "maximum_days_of_limit_calculation",
        type: INPUT_TYPES.NUMBER,
        className: "form-field fb-20 mr-3perc",
        rules: [
            {
                required: true,
                message: "Field is required"
            },
            {
                pattern: /^(0|[1-9]\d*)$/,
                message: "Please enter a number"
            }  
        ]
    },
});

export const PRODUCT_DETAIL_FIELDS = new OrderedMap({
    product_type: {
        className: "form-field fb-30 mr-3perc",
        type: INPUT_TYPES.SELECT,
        label: "Business Product Name",
        rules: [
            {
                required: true,
                message: "Business Product Name is Required"
            }
        ],
        options: BUSINESS_PRODUCT_TYPE.map((value, label) => ({
            label,
            value
        })).toList().toArray(),
        category: 2
    },
    program_type: {
        className: "form-field fb-30 mr-3perc",
        type: INPUT_TYPES.SELECT,
        label: "Program Type",
        rules: [
            {
                required: true,
                message: "Program Type is Required"
            }
        ],
        options: PROGRAM_TYPE_NEW.map((value, label) => ({
            label,
            value
        })).toList().toArray(),
        category: 2
    },
    proposed_program_size_in_cr: {
        key: "proposed_program_size_in_cr",
        label: "Proposed Program Size (crores)",
        dataIndex: "proposed_program_size_in_cr",
        type: INPUT_TYPES.NUMBER,
        className: "form-field fb-30 mr-3perc",
        rules: [
            {
                required: true,
                message: "Field is required"
            },
            {
                pattern: /^(?:\d*\.)?\d+$/,
                message: "Please enter a number"
            }
        ],
        category: 2
    },

    association_type: {
        key: "association_type",
        label: "Association Type",
        dataIndex: "association_type",
        type: INPUT_TYPES.SELECT,
        className: "form-field fb-30 mr-3perc",
        rules: [
            {
                required: true,
                message: "Field is required"
            },
        ],
        options: ONBOARDING_ASSOCIATION_TYPES.map((value, label) => ({
            label,
            value
        })).toList().toArray(),
    },
    proposed_max_ticket_size_in_lacs: {
        key: "proposed_max_ticket_size_in_lacs",
        label: "Proposed Max Ticket Size",
        dataIndex: "proposed_max_ticket_size_in_lacs",
        type: INPUT_TYPES.NUMBER,
        className: "form-field fb-30 mr-3perc",
        rules: [
            {
                required: true,
                message: "Field is required"
            },
            {
                pattern: /^(?:\d*\.)?\d+$/,
                message: "Please enter a number"
            }
        ],
        category: 2
    },


})


export const ADD_NEW_PROGRAM_FIELDS = new OrderedMap({
    product_type: {
        className: "form-field fb-30 mr-3perc",
        type: INPUT_TYPES.SELECT,
        label: "Business Product Name",
        rules: [
            {
                required: true,
                message: "Business Product Name is Required"
            }
        ],
        options: BUSINESS_PRODUCT_TYPE.map((value, label) => ({
            label,
            value
        })).toList().toArray(),
        category: 2
    },
    program_type: {
        className: "form-field fb-30 mr-3perc",
        type: INPUT_TYPES.SELECT,
        label: "Program Type",
        rules: [
            {
                required: true,
                message: "Program Type is Required"
            }
        ],
        options: PROGRAM_TYPE_NEW.map((value, label) => ({
            label,
            value
        })).toList().toArray(),
        category: 2
    },
    proposed_program_size_in_cr: {
        key: "proposed_program_size_in_cr",
        label: "Proposed Program Size (crores)",
        dataIndex: "proposed_program_size_in_cr",
        type: INPUT_TYPES.NUMBER,
        className: "form-field fb-30 mr-3perc",
        rules: [
            {
                required: true,
                message: "Field is required"
            },
            {
                pattern: /^(?:\d*\.)?\d+$/,
                message: "Please enter a number"
            }
        ],
        category: 2
    },

    association_type: {
        key: "association_type",
        label: "Association Type",
        dataIndex: "association_type",
        type: INPUT_TYPES.SELECT,
        className: "form-field fb-30 mr-3perc",
        rules: [
            {
                required: true,
                message: "Field is required"
            },
        ],
        options: ONBOARDING_ASSOCIATION_TYPES.map((value, label) => ({
            label,
            value
        })).toList().toArray(),
    },
    proposed_max_ticket_size_in_lacs: {
        key: "proposed_max_ticket_size_in_lacs",
        label: "Proposed Max ticket Size DB (₹)",
        dataIndex: "proposed_max_ticket_size_in_lacs",
        type: INPUT_TYPES.NUMBER,
        className: "form-field fb-30 mr-3perc",
        rules: [
            {
                required: true,
                message: "Field is required"
            },
            {
                pattern: /^(?:\d*\.)?\d+$/,
                message: "Please enter a number"
            }
        ],
        tooltip: "Exact Value",
        category: 2
    },


})

export const RISK_CONTROLS_FORM  = new OrderedMap({
    recourse_structure: {
        className: "form-field fb-30 mr-3perc",
        type: INPUT_TYPES.SELECT,
        label: "Recourse Structure",
        rules: [
            {
                required: true,
                message: "Field is required"
            },

        ],
        options: RECOURSE_STRUCTURE.map((value, label) => ({
            label,
            value
        })).toList().toArray(),
        col: 8
    },
    recourse_perc: {
        key: "recourse_perc",
        className: "form-field fb-30 mr-3perc",
        label: "Recourse %",
        dataIndex: "recourse_perc",
        type: INPUT_TYPES.NUMBER,
        rules: [
            {
                required: true,
                message: "Field is required"
            },
            {
                pattern: /^(100(\.0{1,2})?|\d{1,2}(\.\d{1,2})?|0(\.\d{1,2})?)$/,
                message: "Input must be between 0 and 100"
            }
        ],
        col: 8
    },
    days_of_guarantee_invocation: {
        key: "days_of_guarantee_invocation",
        label: "Days of Guarantee Invocation",
        dataIndex: "days_of_guarantee_invocation",
        type: INPUT_TYPES.NUMBER,
        className: "form-field fb-30 mr-3perc",
        rules: [
            {
                required: true,
                message: "Field is required"
            },
            {
                pattern: /^(?:\d*\.)?\d+$/,
                message: "Please enter a valid number"
            }
        ],
        col: 8
    },
    security_type: {
        className: "form-field fb-30 mr-3perc",
        type: INPUT_TYPES.SELECT,
        label: "Security Type",
        rules: [
            {
                required: true,
                message: "Security Type is Required"
            }
        ],
        options: SECURITY_TYPES.map((value, label) => ({
            label,
            value
        })).toList().toArray(),
        col: 8
    },
    effective_date: {
        key: "effective_date",
        label: "Effective Date",
        disabled: true,
        dataIndex: "effective_date",
        type: INPUT_TYPES.DATE,
        className: "form-field fb-30 mr-3perc",
        col: 8
    },
    // security_basis: {
    //     className: "form-field fb-30 mr-3perc",
    //     type: INPUT_TYPES.SELECT,
    //     label: "Security Basis",
    //     rules: [
    //         {
    //             required: true,
    //             message: "Security Type is Required"
    //         }
    //     ],
    //     options: SECURITY_BASIS.map((value, label) => ({
    //         label,
    //         value
    //     })).toList().toArray(),
    //     col: 8
    // },
    holdback_calculation_type: {
        label: "Holdback Type",
        className: "form-field fb-20 mr-3perc",
        type: INPUT_TYPES.RADIO,
        defaultValue: 1,
        options: [
            {
                key: "security_perc",
                value: 2,
                label: "Holdback %"
            },
            {
                key: "security_amount",
                value: 1,
                label: "Holdback Amount"
            }
        ],
        col: 24
    },
    security_perc: {
        key: "security_perc",
        label: "Holdback %",
        disabled: true,
        dataIndex: "security_perc",
        type: INPUT_TYPES.NUMBER,
        className: "form-field fb-30 mr-3perc",
        rules: [
            {
                pattern: /^(100(\.0{1,2})?|\d{1,2}(\.\d{1,2})?|0(\.\d{1,2})?)$/,
                message: "Input must be between 0 and 100"
}
        ],
        col: 8
    },
    security_amount: {
        key: "security_amount",
        label: "Holdback Amount",
        dataIndex: "security_amount",
        type: INPUT_TYPES.NUMBER,
        disabled: true,
        className: "form-field fb-30 mr-3perc",
        rules: [
            // {
            //     required: true,
            //     message: "Field is required"
            // },
        ],
        col: 8
    },
    is_churns_applicable: {
        label: "Churn Applicable",
        className: "form-field fb-20 mr-3perc",
        type: INPUT_TYPES.RADIO,
        defaultValue: true,
        options: [
            {
                key: "Yes",
                value: true,
                label: "Yes"
            },
            {
                key: "No",
                value: false,
                label: "No"
            }
        ],
        col: 24
    },
    number_of_churns: {
        key: "number_of_churns",
        label: "No of Churns",
        dataIndex: "number_of_churns",
        type: INPUT_TYPES.NUMBER,
        className: "form-field fb-30 mr-3perc",
        col: 8
    },
    pre_churn_db_security_perc: {
        key: "pre_churn_db_security_perc",
        label: "Pre Churn DB Security %",
        dataIndex: "pre_churn_db_security_perc",
        type: INPUT_TYPES.NUMBER,
        className: "form-field fb-30 mr-3perc",
        rules: [

            {
                pattern: /^(100(\.0{1,2})?|\d{1,2}(\.\d{1,2})?|0(\.\d{1,2})?)$/,
                message: "Input must be between 0 and 100"
            }
        ],
        col: 8
    },
    post_churn_db_security_perc: {
        key: "post_churn_db_security_perc",
        label: "Post Churn DB Security %",
        dataIndex: "post_churn_db_security_perc",
        type: INPUT_TYPES.NUMBER,
        className: "form-field fb-30 mr-3perc",
        rules: [
            {
                pattern: /^(100(\.0{1,2})?|\d{1,2}(\.\d{1,2})?|0(\.\d{1,2})?)$/,
                message: "Input must be between 0 and 100"
        }
        ],
        col: 8
    },
    anchor_recommendation: {
        key: "anchor_recommendation",
        label: "Anchor Recommendation",
        dataIndex: "anchor_recommendation",
        type: INPUT_TYPES.SELECT,
        className: "form-field fb-30 mr-3perc",
        options: [
            {
                key: "Yes",
                value: true,
                label: "Yes"
            },
            {
                key: "No",
                value: false,
                label: "No"
            }
        ],
        rules: [
            {
                required: true,
                message: "Field is required"
            },
        ],
        col: 8
    },
    stock_liquidation: {
        key: "stock_liquidation",
        label: "Stock Liquidation",
        dataIndex: "stock_liquidation",
        type: INPUT_TYPES.SELECT,
        className: "form-field fb-30 mr-3perc",
        options: [
            {
                key: "Yes",
                value: true,
                label: "Yes"
            },
            {
                key: "No",
                value: false,
                label: "No"
            }
        ],
        rules: [
            {
                required: true,
                message: "Field is required"
            },
        ],
        col: 8
    },
    termination_intimation: {
        key: "termination_intimation",
        label: "Termination Intimation",
        dataIndex: "termination_intimation",
        type: INPUT_TYPES.SELECT,
        className: "form-field fb-30 mr-3perc",
        options: [
            {
                key: "Yes",
                value: true,
                label: "Yes"
            },
            {
                key: "No",
                value: false,
                label: "No"
            }
        ],
        rules: [
            {
                required: true,
                message: "Field is required"
            },
        ],
        col: 8
    },
    number_of_dealer_expected: {
        key: "number_of_dealer_expected",
        label: "No. of dealer expected",
        dataIndex: "number_of_dealer_expected",
        type: INPUT_TYPES.NUMBER,
        className: "form-field fb-30 mr-3perc",
        rules: [
            {
                pattern: /^(100(\.0{1,2})?|\d{1,2}(\.\d{1,2})?|0(\.\d{1,2})?)$/,
                message: "Input must be between 0 and 100"
            },
            {
                pattern: /^(0|[1-9]\d*)$/,
                message: "Please enter a number"
            }
        ],
        col: 8
    },
    lor_month_with_anchor: {
        key: "lor_month_with_anchor",
        label: "LOR with Anchor(In Months)",
        dataIndex: "lor_month_with_anchor",
        type: INPUT_TYPES.NUMBER,
        className: "form-field fb-30 mr-3perc",
        rules: [
            {
                required: true,
                message: "Field is required"
            },
            {
                pattern: /^(0|[1-9]\d*)$/,
                message: "Please enter a number"
            }
        ],
        col: 8
    },
    minimum_business_vintage_month: {
        key: "minimum_business_vintage_month",
        label: "Minimum Business Vintage (In Months)",
        dataIndex: "minimum_business_vintage_month",
        type: INPUT_TYPES.NUMBER,
        className: "form-field fb-30 mr-3perc",
        rules: [
            {
                required: true,
                message: "Field is required"
            },
            {
                pattern: /^(0|[1-9]\d*)$/,
                message: "Please enter a number"
            }
        ],
        col: 8
    },
    disbursement_in: {
        key: "disbursement_in",
        label: "Disbursement In",
        dataIndex: "disbursement_in",
        type: INPUT_TYPES.TEXT,
        className: "form-field fb-30 mr-3perc",
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ],
        col: 8
    },
    invoice_process: {
        key: "invoice_process",
        label: "Invoice Process",
        dataIndex: "invoice_process",
        type: INPUT_TYPES.TEXT,
        className: "form-field fb-30 mr-3perc",
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ],
        col: 8
    },
});

export const SCHEME_CONTROLS_FORM_FIELDS = new OrderedMap({
    tenor_max: {
        key: "tenor_max",
        label: "Max Tenor",
        dataIndex: "tenor_max",
        type: INPUT_TYPES.NUMBER,
        className: "form-field fb-30 mr-3perc",
        rules: [
            {
                required: true,
                message: "Field is required"
            },
            {
                pattern: /^(0|[1-9]\d*)$/,
                message: "Please enter a valid number"
            }
        ]
    },
    roi_min_perc: {
        key: "roi_min_perc",
        label: "Min ROI%",
        dataIndex: "roi_min_perc",
        type: INPUT_TYPES.NUMBER,
        className: "form-field fb-30 mr-3perc",
        rules: [
            {
                required: true,
                message: "Field is required"
            },
            {
                pattern: /^(100(\.0{1,2})?|\d{1,2}(\.\d{1,2})?|0(\.\d{1,2})?)$/,
                message: "Input must be between 0 and 100"
}
        ],
    },
    overdue_min_perc: {
        key: "overdue_min_perc",
        label: "Min OD%",
        dataIndex: "overdue_min_perc",
        type: INPUT_TYPES.NUMBER,
        className: "form-field fb-30 mr-3perc",
        rules: [
            {
                required: true,
                message: "Field is required"
            },
            {
                pattern: /^(100(\.0{1,2})?|\d{1,2}(\.\d{1,2})?|0(\.\d{1,2})?)$/,
                message: "Input must be between 0 and 100"
}
        ],
    },
    ticket_size_min: {
        key: "ticket_size_min",
        label: "Min Ticket Size",
        dataIndex: "ticket_size_min",
        type: INPUT_TYPES.NUMBER,
        className: "form-field fb-30 mr-3perc",
        rules: [
            {
                required: true,
                message: "Field is required"
            },
            {
                pattern: /^(?:\d*\.)?\d+$/,
                message: "Please enter a valid number"
            }
        ]
    },
    ticket_size_max: {
        key: "ticket_size_max",
        label: "Max Ticket Size",
        dataIndex: "ticket_size_max",
        type: INPUT_TYPES.NUMBER,
        className: "form-field fb-30 mr-3perc",
        rules: [
            {
                required: true,
                message: "Field is required"
            },
            {
                // pattern: /^(100(\.0{1,2})?|[1-9]\d?(\.\d{1,2})?)$/,
                pattern: /^(?:\d*\.)?\d+$/,
                message: "Please enter a valid number"
            }
        ]
    },
    adhoc_rate_perc: {
        key: "adhoc_rate_perc",
        label: "Min Adhoc Rate%",
        dataIndex: "adhoc_rate_perc",
        type: INPUT_TYPES.NUMBER,
        className: "form-field fb-30 mr-3perc",
        rules: [
            {
                required: true,
                message: "Field is required"
            },
            {
                pattern: /^(100(\.0{1,2})?|\d{1,2}(\.\d{1,2})?|0(\.\d{1,2})?)$/,
                message: "Input must be between 0 and 100"
}
        ],
    },

    dwd_max: {
        key: "dwd_max",
        label: "Max DWD Allowed",
        dataIndex: "dwd_max",
        type: INPUT_TYPES.NUMBER,
        className: "form-field fb-30 mr-3perc",
        rules: [
            {
                required: true,
                message: "Field is required"
            },
            {
                pattern: /^(0|[1-9]\d*)$/,
                message: "Please enter a valid number"
            }
        ]
    },
    subvention_perc: {
        key: "subvention_perc",
        label: "Min Subvention % Allowed",
        dataIndex: "subvention_perc",
        type: INPUT_TYPES.NUMBER,
        className: "form-field fb-30 mr-3perc",
        rules: [
            {
                required: true,
                message: "Field is required"
            },
            {
                pattern: /^(100(\.0{1,2})?|\d{1,2}(\.\d{1,2})?|0(\.\d{1,2})?)$/,
                message: "Input must be between 0 and 100"
}
        ],
    },

    sbd_days: {
        key: "sbd_days",
        label: "Max SBD Days",
        dataIndex: "sbd_days",
        type: INPUT_TYPES.NUMBER,
        className: "form-field fb-30 mr-3perc",
        rules: [
            {
                required: true,
                message: "Field is required"
            },
            {
                pattern: /^(0|[1-9]\d*)$/,
                message: "Please enter a number"
                
            }
        ]
    },

    blended_roi_target_perc: {
        key: "blended_roi_target_perc",
        label: "Blended ROI Target %",
        dataIndex: "blended_roi_target_perc",
        type: INPUT_TYPES.NUMBER,
        className: "form-field fb-30 mr-3perc",
        rules: [
            {
                required: true,
                message: "Field is required"
            },
            {
                pattern: /^(100(\.0{1,2})?|\d{1,2}(\.\d{1,2})?|0(\.\d{1,2})?)$/,
                message: "Input must be between 0 and 100"
}
        ],
    },
    minimum_processing_fee_perc: {
        key: "minimum_processing_fee_perc",
        label: "Minimum Pf%",
        dataIndex: "minimum_processing_fee_perc",
        type: INPUT_TYPES.NUMBER,
        className: "form-field fb-30 mr-3perc",
        rules: [
            {
                required: true,
                message: "Field is required"
            },
            {
                pattern: /^(100(\.0{1,2})?|\d{1,2}(\.\d{1,2})?|0(\.\d{1,2})?)$/,
                message: "Input must be between 0 and 100"
}
        ],
    },
    minimum_documentation_charges: {
        key: "minimum_documentation_charges",
        label: "Minimum Doc Charges",
        dataIndex: "minimum_documentation_charges",
        type: INPUT_TYPES.NUMBER,
        className: "form-field fb-30 mr-3perc",
        rules: [
            {
                required: true,
                message: "Field is required"
            },
            {
                pattern: /^(0|[1-9]\d*)$/,
                message: "Please enter a number"
            }
        ]
    },
    cooling_period: {
        key: "cooling_period",
        label: "Cooling Period",
        dataIndex: "cooling_period",
        type: INPUT_TYPES.NUMBER,
        className: "form-field fb-30 mr-3perc",
        rules: [
            {
                required: true,
                message: "Field is required"
            },
            {
                pattern: /^(0|[1-9]\d*)$/,
                message: "Please enter a number"
            }
        ]
    },
    stop_supply: {
        key: "stop_supply",
        label: "Stop Supply",
        dataIndex: "stop_supply",
        type: INPUT_TYPES.SELECT,
        className: "form-field fb-30 mr-3perc",
        options: [
            {
                key: "Yes",
                value: true,
                label: "Yes"
            },
            {
                key: "No",
                value: false,
                label: "No"
            }
        ],
        rules: [
            {
                required: true,
                message: "Field is required"
            },
        ]
    },
    
});


export const DISBURSAL_CONTROLS_FIELDS = new OrderedMap({
    days_of_stale_invoice: {
        key: "days_of_stale_invoice",
        label: "Days for Stale Invoice",
        dataIndex: "days_of_stale_invoice",
        // width: 0,
        type: INPUT_TYPES.NUMBER,
        className: "form-field fb-20 mr-3perc",
        rules: [
            {
                required: true,
                message: "Field is required"
            },
            {
                pattern: /^(0|[1-9]\d*)$/,
                message: "Please enter a number"
            }
        ]
    },
    is_buyer_invoice_approval_needed: {
        label: "Buyer Invoice Approval Needed?",
        className: "form-field fb-20 mr-3perc",
        type: INPUT_TYPES.RADIO,
        defaultValue: false,
        options: [
            {
                key: "Yes",
                value: true,
                label: "Yes"
            },
            {
                key: "No",
                value: false,
                label: "No"
            }
        ],
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ]
    },
    is_sync_based_disbursal_mandatory: {
        label: "Sync Based Disbursal Mandatory?",
        className: "form-field fb-20 mr-3perc",
        type: INPUT_TYPES.RADIO,
        defaultValue: false,
        options: [
            {
                key: "Yes",
                value: true,
                label: "Yes"
            },
            {
                key: "No",
                value: false,
                label: "No"
            }
        ],
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ]
    },
    invoice_type_allowed: {
        key: "invoice_type_allowed",
        label: "Invoice Type Allowed",
        dataIndex: "invoice_type_allowed",
        type: INPUT_TYPES.SELECT,
        className: "form-field fb-30 mr-3perc",
        options: [
            {
                key: 1,
                value: 1,
                label: "Invoice Based"
            },
            {
                key: 2,
                value: 2,
                label: "PO Based"
            },
            {
                key: 3,
                value: 3,
                label: "DRF"
            },
        ],
        rules: [
            {
                required: true,
                message: "Field is required"
            },
        ]
    },
    is_bulk_invoice_upload_allowed: {
        key: "is_bulk_invoice_upload_allowed",
        label: "Is Excel Bulk Invoice Allowed",
        dataIndex: "is_bulk_invoice_upload_allowed",
        type: INPUT_TYPES.RADIO,
        className: "form-field fb-30 mr-3perc",
        options: [
            {
                key: "Yes",
                value: true,
                label: "Yes"
            },
            {
                key: "No",
                value: false,
                label: "No"
            }
        ],
        rules: [
            {
                required: true,
                message: "Field is required"
            },
        ]
    },
});

export const E_NACH_FORM_FIELDS = (caseAssociates) => new OrderedMap({
    // first_name: {
    //     type: INPUT_TYPES.TEXT,
    //     placeholder: "Acc",
    //     className: "form-field",
    //     rules: [
    //         {
    //             required: true,
    //             message: "First Name is Required"
    //         }
    //     ]
    // },
    // account_type: {
    //     type: INPUT_TYPES.SELECT,
    //     options: BANK_ACCOUNT_TYPES.map((value, label) => ({
    //         value,
    //         label
    //     })).toList(),
    //     rules: [
    //         {
    //             required: true,
    //             message: "Field is required"
    //         }
    //     ],
    //     label: "Account Type",
    //     className: "form-field fb-33"
    // },
    mandate_type: {
        className: "form-field",
        type: INPUT_TYPES.SELECT,
        label: "NACH Mode",
        placeholder: "NACH Mode",
        disabled: true,
        options: NACH_MODES_TYPE.map((_, label) => ({
            value: _.value,
            label: _.label
        })).toList(),
        offset : 0,
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ],
    },
    associate: {
        className: "form-field",
        type: INPUT_TYPES.SELECT,
        label: "Applicant",
        placeholder: "Applicant",
        disabled: true,
        options:caseAssociates.map(_ => ({
            value: _.company_associate.id,
            label: _.company_associate.first_name

        })),
        offset : 1,
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ],
    },
});


export const BANKING_SURROGATE_FORM_FIELDS = new OrderedMap({
    abb_last_six_months: {
        type: INPUT_TYPES.NUMBER,
        label: "ABB last 6 months- Current Account (A)",
        style: {width: 250},
        rules : [
            {
                required: true,
                message: "Field is mandatory"
            },
            {
                pattern: /^\d+(\.\d{1,2})?$/,
                message: "Please enter a valid number"
            }
        ],
        className: "form-field fb-30 mr-3perc",
        showInputBgColor : true
    },
    od_limit: {
        type: INPUT_TYPES.NUMBER,
        label: "OD Limit",
        style: {width: 250},
        rules : [
            {
                required: true,
                message: "Field is mandatory"
            },
            {
                pattern: /^\d+(\.\d{1,2})?$/,
                message: "Please enter a valid number"
            }
        ],
        className: "form-field fb-20 mr-3perc",
        showInputBgColor : true
    },
    average_utilized_limit: {
        type: INPUT_TYPES.NUMBER,
        label: "Average Utilized Limit",
        style: {width: 250},
        rules : [
            {
                required: true,
                message: "Field is mandatory"
            },
            {
                pattern: /^-?\d+(\.\d{1,2})?$/,
                message: "Please enter a valid number"
            }
        ],
        className: "form-field fb-20 mr-3perc mb-5",
        showInputBgColor : true
    },
    unutilised_limit: {
        type: INPUT_TYPES.NUMBER,
        label: "Unutilised Limit",
        style: {width: 250},
        rules : [
            {
                required: true,
                message: "Field is mandatory"
            }
        ],
        disabled: true,
        className: "form-field fb-20 mr-3perc mb-5",
    },
    total_abb: {
        type: INPUT_TYPES.NUMBER,
        label: "Total ABB (B)",
        style: {width: 250},
        disabled: true,
        rules : [
            {
                required: true,
                message: "Field is mandatory"
            }
        ],
        className: "form-field fb-20 mr-3perc mb-5",
    },
    max_emi_eligibility: {
        type: INPUT_TYPES.NUMBER,
        label: "Max EMI Eligibility (B*C)",
        style: {width: 250},
        rules : [
            {
                required: true,
                message: "Field is mandatory"
            },
            {
                pattern: /^\d+(\.\d{1,2})?$/,
                message: "Please enter a valid number"
            }
        ],
        disabled: true,
        className: "form-field fb-20 mr-3perc mb-5",
    },
   
    margin_b: {
        type: INPUT_TYPES.NUMBER,
        label: "Margin (C)",
        rules : [
            {
                required: true,
                message: "Field is mandatory"
            },
            {
                pattern: /^\d+(\.\d{1,2})?$/,
                message: "Please enter a valid number"
            }
        ],
        style: {width: 250},
        className: "form-field fb-20 mr-3perc mb-5",
        showInputBgColor : true
    },
    tenor_c: {
        type: INPUT_TYPES.NUMBER,
        label: "Tenor (D)",
        style: {width: 250},
        rules : [
            {
                required: true,
                message: "Field is mandatory"
            },
            {
                pattern: /^\d+(\.\d{1,2})?$/,
                message: "Please enter a valid number"
            }
        ],
        className: "form-field fb-20 mr-3perc mb-5",
        showInputBgColor : true
    },
    max_loan_eligibility_abc: {
        type: INPUT_TYPES.NUMBER,
        label: "Max Loan Eligibility (B*C*D)",
        style: {width: 250},
        rules : [
            {
                required: true,
                message: "Field is mandatory"
            }
        ],
        disabled: true,
        className: "form-field fb-20 mr-3perc mb-5",
    },
});




export const GST_BASED_FORM_FIELDS = new OrderedMap({
    gst_topline_last_twelve_months_a: {
        type: INPUT_TYPES.NUMBER,
        label: "GST Topline- last 12 months (A)",
        style: {width: 250},
        rules : [
            {
                required: true,
                message: "Field is mandatory"
            },
            {
                pattern: /^\d+(\.\d{1,2})?$/,
                message: "Please enter a valid number"
            }
        ],
        className: "form-field fb-20 mr-3perc mb-5",
        showInputBgColor : true

    },
    margin_b_gst: {
        type: INPUT_TYPES.NUMBER,
        label: "Margin (B)",
        style: {width: 250},
        rules : [
            {
                required: true,
                message: "Field is mandatory"
            },
            {
                pattern: /^(100|[1-9]?[0-9](\.\d{1,2})?)$/,
                message: "Enter number between 0 to 100"
            }
        ],
        className: "form-field fb-20 mr-3perc mb-5",
        showInputBgColor : true
    },
    foir_c: {
        type: INPUT_TYPES.NUMBER,
        label: "FOIR (C)",
        style: {width: 250},
        rules : [
            {
                required: true,
                message: "Field is mandatory"
            },
            {
                pattern: /^(100|[1-9]?[0-9](\.\d{1,2})?)$/,
                message: "Enter number between 0 to 100"
            }
        ],
        className: "form-field fb-20 mr-3perc mb-5",
        showInputBgColor : true
    },
    max_eligibility_d: {
        type: INPUT_TYPES.NUMBER,
        label: "Max Eligibility (D)(A*B*C)",
        style: {width: 250},
        disabled: true,
        rules : [
            {
                required: true,
                message: "Field is mandatory"
            }
        ],
        className: "form-field fb-20 mr-3perc mb-5",

    },
    current_obligation_running_emi_for_twelve_months_e: {
        type: INPUT_TYPES.NUMBER,
        label: "Current Obligation (Running EMI for 12 months) (E)",
        style: {width: 250},
        rules : [
            {
                required: true,
                message: "Field is mandatory"
            },
            {
                pattern: /^\d+(\.\d{1,2})?$/,
                message: "Please enter a valid number"
            }
        ],
        className: "form-field fb-20 mr-3perc mb-5",
        showInputBgColor : true
    },
    max_loan_eligibility_d_e: {
        type: INPUT_TYPES.NUMBER,
        label: "Max Loan Eligibility (D-E)",
        style: {width: 250},
        disabled: true,
        rules : [
            {
                required: true,
                message: "Field is mandatory"
            }
        ],
        className: "form-field fb-20 mr-3perc mb-5",
    }
});


export const FINANCIAL_BASES_FORM_FIELDS = new OrderedMap({
    pat_a: {
        type: INPUT_TYPES.NUMBER,
        label: "PAT (A)",
        style: {width: 250},
        rules : [
            {
                required: true,
                message: "Field is mandatory"
            },
            {
                pattern: /^\d+(\.\d{1,2})?$/,
                message: "Please enter a valid number"
            }
        ],
        className: "form-field fb-20 mr-3perc mb-5",
        showInputBgColor : true
    },
    interest_b_financial: {
        type: INPUT_TYPES.NUMBER,
        label: "Interest (B)",
        style: {width: 250},
        rules : [
            {
                required: true,
                message: "Field is mandatory"
            },
            {
                pattern: /^\d+(\.\d{1,2})?$/,
                message: "Please enter a valid number"
            }
        ],
        className: "form-field fb-20 mr-3perc mb-5",
        showInputBgColor : true
    },
    depriciation_c: {
        type: INPUT_TYPES.NUMBER,
        label: "Depriciation (C)",
        style: {width: 250},
        rules : [
            {
                required: true,
                message: "Field is mandatory"
            },
            {
                pattern: /^\d+(\.\d{1,2})?$/,
                message: "Please enter a valid number"
            }
        ],
        className: "form-field fb-20 mr-3perc mb-5",
        showInputBgColor : true
    },
    partner_remuneration_int_on_capital: {
        type: INPUT_TYPES.NUMBER,
        label: "Partner Remuneration (D) + Int on Capital",
        style: {width: 250},
        rules : [
            {
                required: true,
                message: "Field is mandatory"
            },
            {
                pattern: /^\d+(\.\d{1,2})?$/,
                message: "Please enter a valid number"
            }
        ],
        className: "form-field fb-20 mr-3perc mb-5",
        showInputBgColor : true
    },
    ebidta_partner_remuneration: {
        type: INPUT_TYPES.NUMBER,
        label: "EBITDA + Partner remuneration (A+B+C+D) - tax",
        disabled: true,
        style: {width: 250},
        rules : [
            {
                required: true,
                message: "Field is mandatory"
            }
        ],
        className: "form-field fb-20 mr-3perc mb-5",
    },
    twelve_month_existing_emi: {
        type: INPUT_TYPES.NUMBER,
        label: "12 month existing EMI (F)",
        style: {width: 250},
        rules : [
            {
                required: true,
                message: "Field is mandatory"
            },
            {
                pattern: /^\d+(\.\d{1,2})?$/,
                message: "Please enter a valid number"
            }
        ],
        className: "form-field fb-20 mr-3perc mb-5",
        showInputBgColor : true
    },
    twelve_month_new_emi: {
        type: INPUT_TYPES.NUMBER,
        label: "12 month New EMI (G)",
        style: {width: 250},
        rules : [
            {
                required: true,
                message: "Field is mandatory"
            },
            {
                pattern: /^\d+(\.\d{1,2})?$/,
                message: "Please enter a valid number"
            }
        ],
        className: "form-field fb-20 mr-3perc mb-5",
        showInputBgColor : true
    },
    debt_service: {
        type: INPUT_TYPES.NUMBER,
        label: "Debt Service (F+G+B)",
        style: {width: 250},
        disabled: true,
        rules : [
            {
                required: true,
                message: "Field is mandatory"
            }
        ],
        className: "form-field fb-20 mr-3perc mb-5",
    },
    dscr_post: {
        type: INPUT_TYPES.NUMBER,
        label: "DSCR (Post) (EBITDA / Debt Service)",
        style: {width: 250},
        disabled: true,
        rules : [
            {
                required: true,
                message: "Field is mandatory"
            }
        ],
        className: "form-field fb-20 mr-3perc mb-5",
        disabled: true,
    }

});

export const WORKING_CAPITAL_GAP_FORM_FIELDS = new OrderedMap({
    stock_in_days: {
        type: INPUT_TYPES.NUMBER,
        label: "Stock (In days)",
        style: {width: 250},
        className: "form-field fb-20 mr-3perc mb-5",
        showInputBgColor : true
    },
    debtors_in_days: {
        type: INPUT_TYPES.NUMBER,
        label: "Debtors (In days)",
        style: {width: 250},
        className: "form-field fb-20 mr-3perc mb-5",
        showInputBgColor : true
    },
    creditor_in_days: {
        type: INPUT_TYPES.NUMBER,
        label: "Creditor (In days)",
        style: {width: 250},
        className: "form-field fb-20 mr-3perc mb-5",
        showInputBgColor : true
    },
    working_capital_cycle: {
        type: INPUT_TYPES.NUMBER,
        label: "Working capital cycle",
        style: {width: 250},
        disabled: true,
        className: "form-field fb-20 mr-3perc mb-5",
    },
    last_twelve_months_sales: {
        type: INPUT_TYPES.NUMBER,
        label: "Last 12 months Sales (Based GST/Financials)",
        style: {width: 250},
        className: "form-field fb-20 mr-3perc mb-5",
        showInputBgColor : true
    },
    working_capital_requirement: {
        type: INPUT_TYPES.NUMBER,
        label: "Working Capital Requirement",
        style: {width: 250},
        disabled: true,
        className: "form-field fb-20 mr-3perc mb-5",
    },
    existing_working_capital_limits: {
        type: INPUT_TYPES.NUMBER,
        label: "Existing Working Capital Limits",
        style: {width: 250},
        className: "form-field fb-20 mr-3perc mb-5",
        showInputBgColor : true
    },
    eligibility_working_capital: {
        type: INPUT_TYPES.NUMBER,
        label: "Eligibility",
        disabled: true,
        style: {width: 250},
        className: "form-field fb-20 mr-3perc mb-5",
    },
});

export const CURRENT_ASSET_METHOD_FORM_FIELDS =  new OrderedMap({
    stoct_current_asset: {
        type: INPUT_TYPES.NUMBER,
        label: "Stock",
        style: {width: 250},
        className: "form-field fb-20 mr-3perc mb-5",
        showInputBgColor : true
    },
    stock_wip: {
        type: INPUT_TYPES.NUMBER,
        label: "Stock WIP",
        style: {width: 250},
        className: "form-field fb-20 mr-3perc mb-5",
        showInputBgColor : true
    },
    current_asset_debtors: {
        type: INPUT_TYPES.NUMBER,
        label: "Debtors",
        style: {width: 250},
        className: "form-field fb-20 mr-3perc mb-5",
        showInputBgColor : true
    },
    total_current_asset: {
        type: INPUT_TYPES.NUMBER,
        label: "Total Current Assets",
        style: {width: 250},
        disabled: true,
        className: "form-field fb-20 mr-3perc mb-5",
    },
    current_asset_eligibility: {
        type: INPUT_TYPES.NUMBER,
        label: "Eligibility",
        style: {width: 250},
        disabled: true,
        className: "form-field fb-20 mr-3perc mb-5",
    },
});

export const INDUSTRY_SEGMENT_BASED_FORM_FIELDS = new OrderedMap({
    industry_segment_gst_topline_last_twelve_month: {
        type: INPUT_TYPES.NUMBER,
        label: "GST topline (A) last 12 month",
        style: {width: 250},
        className: "form-field fb-20 mr-3perc mb-5",
        showInputBgColor : true
    },
    industry_wise_working_capital_cycle: {
        type: INPUT_TYPES.SELECT,
        label: "Industry wise working capital cycle",
        style: {width: 250},
        className: "form-field fb-20 mr-3perc mb-5",
        showInputBgColor : true,
        options: [
            {
                label: "White Goods/FMEG",
                value: 90
            },
            {
                label: "Agriculture",
                value: 180
            },
            {
                label: "Auto/Battery",
                value: 75
            },
            {
                label: "Mobile/FMCG",
                value: 30
            },
            {
                label: "Other Industry (Not Listed Above)",
                value: 60
            },

        ]
    },
    industry_segment_eligibility: {
        type: INPUT_TYPES.NUMBER,
        label: "Eligibility",
        disabled: true,
        style: {width: 250},
        className: "form-field fb-20 mr-3perc mb-5",
    },
    existing_loans: {
        type: INPUT_TYPES.NUMBER,
        label: "Existing loans",
        style: {width: 250},
        className: "form-field fb-20 mr-3perc mb-5",
        showInputBgColor : true
    },
    industry_segment_max_eligibility: {
        type: INPUT_TYPES.NUMBER,
        label: "Max Eligibility",
        disabled: true,
        style: {width: 250},
        className: "form-field fb-20 mr-3perc mb-5",
    },
})

export const TERM_LOAN_FORM_FIELDS = new OrderedMap({
    tenor: {
        type: INPUT_TYPES.NUMBER,
        className:"form-field fb-30 mr-3perc",
        label: "Tenure",
        rules: [
            {
                required: true,
                message: "Field is mandatory"
            },
            {
                pattern: /^(1[0-2]|[1-9])(\.\d{1,2})?$/,
                message: "Please enter a valid number between 1 to 12"
            }
        ],
    },
    roi: {
        type: INPUT_TYPES.NUMBER,
        className:"form-field fb-30 mr-3perc",
        label: "ROI",
        rules: [
            {
                required: true,
                message: "Field is mandatory"
            },
            {
                pattern: /^(3[0-6]|[1-2]?\d)(\.\d{1,3})?$/,
                message: "Please enter a valid number between 1 to 36"
            }
        ]
    }
});


export const PD_DECLARATION_FORM_FIELDS  = new OrderedMap({
    group_entity_involved: {
        label: "Group Entity Involved",
        type: INPUT_TYPES.RADIO,
        defaultValue: false,
        options: [{ label: "Yes", value: true }, { label: "No", value: false }],
        className: "form-field fb-30",
    },
    existing_sanctioned_limit: {
        key: "existing_sanctioned_limit",
        label: "Existing Sanctioned Limit",
        type: INPUT_TYPES.NUMBER,
        className: "form-fiel w-60",
        helpMessage: "Maximum value: ₹20,00,00,000 (20 Cr)",
        rules: [
            {
                required: true,
                message: "Field is required"
            },
        ]
    },
     sales_limit_ask: {
        key: "sales_limit_ask",
        label: "Sales Limit Ask",
        type: INPUT_TYPES.NUMBER,
        className: "form-fiel w-60",
        helpMessage: "Maximum value: ₹20,00,00,000 (20 Cr)",
        rules: [
            {
                required: true,
                message: "Field is required"
            },
        ]
    },
    loan_from_other_lenders: {
        key: "loan_from_other_lenders",
        label: "Loan from Other Lenders",
        type: INPUT_TYPES.NUMBER,
        className: "form-fiel w-60",
        helpMessage: "Maximum value: ₹20,00,00,000 (20 Cr)",
        rules: [
            {
                required: true,
                message: "Field is required"
            },
        ]
    },
});
